(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  const imageCol = document.querySelector('.article__image-column');
  if (imageCol) {
    const update = () => {
      const colHeight = imageCol.offsetHeight;
      const vh = window.innerHeight;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--total-header-height')) || 110;
      const bottomMargin = 40;
      const topWhenSmall = headerHeight + 40;

      if (colHeight > vh - topWhenSmall - bottomMargin) {
        imageCol.style.setProperty('--sticky-top', `${vh - colHeight - bottomMargin}px`);
      } else {
        imageCol.style.setProperty('--sticky-top', `${topWhenSmall}px`);
      }
    };

    const img = imageCol.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener('load', update);
    }
    update();
    window.addEventListener('resize', update);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-redirect"]) return;
  try {
    
  (function redirectToSidecart() {
    function openAndLeave() {
      try {
        document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (e) {}
      var fallback = '/';
      var target = fallback;
      try {
        var ref = document.referrer;
        if (ref && ref.indexOf(window.location.origin) === 0 && ref.indexOf('/cart') === -1) {
          target = ref;
        }
      } catch (e) {}
      if (target === window.location.href) target = fallback;
      window.location.replace(target);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openAndLeave);
    } else {
      openAndLeave();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  class ProductCardVideo {
    constructor() {
      this.cards = document.querySelectorAll('[data-product-card]');
      if (!this.cards.length) return;
      this.init();
    }

    init() {
      this.cards.forEach(card => {
        const video = card.querySelector('[data-product-video]');
        if (!video) return;

        const imageLink = card.querySelector('.product-card__image-link');

        const playVideo = () => {
          video.play().catch(() => {});
        };

        const pauseVideo = () => {
          video.pause();
          video.currentTime = 0;
        };

        card.addEventListener('mouseenter', playVideo);
        card.addEventListener('mouseleave', pauseVideo);

        if (imageLink) {
          imageLink.addEventListener('focus', playVideo);
          imageLink.addEventListener('blur', pauseVideo);
        }
      });
    }
  }

  function initProductCardVideos() {
    if (!document.querySelector('[data-product-video]')) return;
    new ProductCardVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardVideos);
  } else {
    initProductCardVideos();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
  class CookieConsent extends HTMLElement {
    connectedCallback() {
      this.banner = this.querySelector('[data-banner]');
      this.bannerCard = this.querySelector('.cookie-banner__card');
      this.modal = this.querySelector('[data-modal]');
      this.dialog = this.querySelector('.cookie-modal__dialog');
      this.lastFocus = null;

      this.addEventListener('click', (event) => {
        const action = event.target.closest('[data-action]');
        if (action) {
          this.handleAction(action.dataset.action);
          return;
        }
        if (event.target.closest('[data-modal-close]')) this.closeModal();
      });

      this.keyHandler = (event) => {
        if (event.key === 'Escape' && !this.modal.hidden) this.closeModal();
        if (event.key === 'Tab' && !this.modal.hidden) this.trapFocus(event);
      };
      document.addEventListener('keydown', this.keyHandler);

      this.reopenHandler = (event) => {
        if (event.target.closest('[data-cookie-settings]')) {
          event.preventDefault();
          this.openModal();
        }
      };
      document.addEventListener('click', this.reopenHandler);
      document.addEventListener('cookie-consent:open', () => this.openModal());

      if (window.Shopify && window.Shopify.designMode) {
        this.setupEditorPreview();
      } else {
        this.withPrivacyApi(() => this.maybeShowBanner());
      }
    }

    setupEditorPreview() {
      this.renderEditorPreview();
      document.addEventListener('shopify:section:select', () => this.renderEditorPreview());
    }

    renderEditorPreview() {
      if (this.dataset.editorPreview === 'modal') {
        this.hideBanner();
        this.openModal();
      } else {
        this.closeModal();
        this.showBanner();
      }
    }

    maybeShowBanner() {
      // If the visitor already chose, never re-show — regardless of region.
      if (this.hasDecided()) return;

      try {
        if (window.Shopify.customerPrivacy.shouldShowBanner()) {
          this.showBanner();
          return;
        }
      } catch (e) {
        /* API unavailable — fall through to the region-independent rule */
      }

      // "Show until the visitor chooses": show everywhere until a choice is made.
      if (this.dataset.alwaysShow === 'true') this.showBanner();
    }

    hasDecided() {
      try {
        if (localStorage.getItem('baudie_cookie_choice') === '1') return true;
      } catch (e) {
        /* localStorage unavailable — fall back to the cookie/API below */
      }
      if (document.cookie.indexOf('baudie_cookie_choice=1') !== -1) return true;
      try {
        const c = this.consent().currentVisitorConsent() || {};
        return Boolean(c.marketing || c.analytics || c.preferences || c.sale_of_data);
      } catch (e) {
        return false;
      }
    }

    rememberChoice() {
      try {
        localStorage.setItem('baudie_cookie_choice', '1');
      } catch (e) {
        /* ignore */
      }
      document.cookie = 'baudie_cookie_choice=1; path=/; max-age=31536000; samesite=lax';
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.keyHandler);
      document.removeEventListener('click', this.reopenHandler);
    }

    handleAction(action) {
      if (action === 'accept') this.acceptAll();
      else if (action === 'decline') this.declineAll();
      else if (action === 'manage') this.openModal();
      else if (action === 'save') this.saveChoices();
    }

    withPrivacyApi(callback) {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        callback();
        return;
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (!error && window.Shopify.customerPrivacy) callback();
          }
        );
      }
    }

    consent() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }

    showBanner() {
      this.banner.hidden = false;
    }

    hideBanner() {
      this.banner.hidden = true;
    }

    openModal() {
      this.lastFocus = document.activeElement;
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      this.syncCheckboxes();
      const focusable = this.focusable();
      if (focusable.length) focusable[0].focus();
    }

    closeModal() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    focusable() {
      return Array.from(
        this.dialog.querySelectorAll(
          'button, [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    trapFocus(event) {
      const items = this.focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    setConsent(values) {
      this.withPrivacyApi(() => {
        try {
          this.consent().setTrackingConsent(values, () => {});
        } catch (e) {
          /* ignore */
        }
      });
    }

    dismiss() {
      this.rememberChoice();
      this.hideBanner();
      this.closeModal();
    }

    acceptAll() {
      this.setConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
      this.dismiss();
    }

    declineAll() {
      this.setConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
      this.dismiss();
    }

    saveChoices() {
      const marketing = this.isChecked('marketing');
      this.setConsent({
        analytics: this.isChecked('analytics'),
        preferences: this.isChecked('preferences'),
        marketing: marketing,
        sale_of_data: marketing,
      });
      this.dismiss();
    }

    isChecked(category) {
      const input = this.querySelector(`[data-category="${category}"]`);
      return input ? input.checked : false;
    }

    syncCheckboxes() {
      let current = {};
      this.withPrivacyApi(() => {
        try {
          current = this.consent().currentVisitorConsent() || {};
        } catch (e) {
          current = {};
        }
      });
      this.querySelectorAll('[data-category]').forEach((input) => {
        input.checked = current[input.dataset.category] === 'yes';
      });
    }
  }

  if (!customElements.get('cookie-consent')) {
    customElements.define('cookie-consent', CookieConsent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"] && !Shopify.designMode) return;
  try {
    
class CustomerCare {
  constructor() {
    this.section = document.querySelector('[data-customer-care]');
    if (!this.section) return;

    this.tabs = this.section.querySelectorAll('[data-tab]');
    this.panels = this.section.querySelectorAll('[data-panel]');
    this.dropdownTrigger = this.section.querySelector('[data-dropdown-trigger]');
    this.dropdownList = this.section.querySelector('[data-dropdown-list]');
    this.dropdownLabel = this.section.querySelector('[data-dropdown-label]');
    this.dropdownItems = this.section.querySelectorAll('[data-dropdown-item]');
    this.accordionTriggers = this.section.querySelectorAll('[data-accordion-trigger]');

    this.bindEvents();
    this.initFromUrl();
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
    });

    if (this.dropdownTrigger) {
      this.dropdownTrigger.addEventListener('click', () => this.toggleDropdown());
    }

    this.dropdownItems.forEach(item => {
      item.addEventListener('click', () => {
        this.switchTab(item.dataset.dropdownItem);
        this.closeDropdown();
      });
    });

    document.addEventListener('click', (e) => {
      const isDropdownOpen = this.dropdownTrigger?.getAttribute('aria-expanded') === 'true';
      if (isDropdownOpen && !this.section.contains(e.target)) {
        this.closeDropdown();
      }
    });

    this.accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.toggleAccordion(trigger));
    });

    window.addEventListener('hashchange', () => this.initFromUrl());
    this.section.addEventListener('keydown', (e) => this.handleKeydown(e));
  }

  initFromUrl() {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const matchingTab = this.section.querySelector(`[data-tab="${hash}"]`);
      if (matchingTab) {
        this.switchTab(hash, false);
        return;
      }
    }
    const firstTab = this.section.querySelector('[data-tab]');
    if (firstTab) {
      this.updateBreadcrumb(firstTab.dataset.tab);
    }
  }

  switchTab(tabId, updateUrl = true) {
    this.tabs.forEach(tab => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('customer-care__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach(panel => {
      const isActive = panel.dataset.panel === tabId;
      panel.classList.toggle('customer-care__panel--active', isActive);
      panel.hidden = !isActive;
    });

    this.dropdownItems.forEach(item => {
      const isActive = item.dataset.dropdownItem === tabId;
      item.classList.toggle('customer-care__dropdown-item--active', isActive);
      if (isActive && this.dropdownLabel) {
        this.dropdownLabel.textContent = item.textContent.trim();
      }
    });

    this.updateBreadcrumb(tabId);

    if (updateUrl) {
      history.pushState(null, '', `#${tabId}`);
    }
  }

  updateBreadcrumb(tabId) {
    const breadcrumbText = document.querySelector('[data-breadcrumb-current-text]');
    if (!breadcrumbText) return;

    const sectionId = this.section.dataset.breadcrumbSectionId;
    const scriptEl = document.getElementById(`breadcrumb-labels-${sectionId}`);
    if (!scriptEl) return;

    try {
      const breadcrumbLabels = JSON.parse(scriptEl.textContent);
      const label = breadcrumbLabels[tabId];
      if (label) {
        breadcrumbText.textContent = label;
      }
    } catch (e) {}
  }

  toggleDropdown() {
    const isOpen = this.dropdownTrigger.getAttribute('aria-expanded') === 'true';
    this.dropdownTrigger.setAttribute('aria-expanded', !isOpen);
    this.dropdownList.setAttribute('aria-hidden', isOpen);
    this.dropdownList.classList.toggle('customer-care__dropdown--open', !isOpen);
  }

  closeDropdown() {
    if (this.dropdownTrigger) {
      this.dropdownTrigger.setAttribute('aria-expanded', 'false');
    }
    if (this.dropdownList) {
      this.dropdownList.setAttribute('aria-hidden', 'true');
      this.dropdownList.classList.remove('customer-care__dropdown--open');
    }
  }

  toggleAccordion(trigger) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const panel = trigger.closest('[data-panel]');

    if (panel) {
      panel.querySelectorAll('[data-accordion-trigger]').forEach(otherTrigger => {
        if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
          this.closeAccordion(otherTrigger);
        }
      });
    }

    if (isExpanded) {
      this.closeAccordion(trigger);
    } else {
      this.openAccordion(trigger);
    }
  }

  openAccordion(trigger) {
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const item = trigger.closest('[data-accordion-item]');

    trigger.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    item.classList.add('customer-care__accordion-item--open');
    content.style.height = content.scrollHeight + 'px';

    content.addEventListener('transitionend', function handler() {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        content.style.height = 'auto';
      }
      content.removeEventListener('transitionend', handler);
    }, { once: true });
  }

  closeAccordion(trigger) {
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const item = trigger.closest('[data-accordion-item]');

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;
    trigger.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    item.classList.remove('customer-care__accordion-item--open');
    content.style.height = '0';
  }

  handleKeydown(e) {
    if (e.target.matches('[data-tab]')) {
      const tabs = Array.from(this.tabs);
      const currentIndex = tabs.indexOf(e.target);

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % tabs.length;
        tabs[nextIndex].focus();
        this.switchTab(tabs[nextIndex].dataset.tab);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        tabs[prevIndex].focus();
        this.switchTab(tabs[prevIndex].dataset.tab);
      }
    }

    if (e.target.matches('[data-accordion-trigger]') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      this.toggleAccordion(e.target);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CustomerCare());
} else {
  new CustomerCare();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-customer-care]')) {
      new CustomerCare();
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('[data-customer-care]');
    if (section) {
      const slug = e.target.querySelector('[data-tab]')?.dataset.tab ||
                   e.target.closest('[data-panel]')?.dataset.panel;
      if (slug) {
        const tab = section.querySelector(`[data-tab="${slug}"]`);
        if (tab) tab.click();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Wires every [data-klaviyo-subscribe] form on the page (footer + newsletter
  // section) to Klaviyo's client subscribe API, keeping the custom markup.
  class KlaviyoSubscribe {
    constructor(form) {
      this.form = form;
      this.company = form.getAttribute('data-klaviyo-company');
      this.list = form.getAttribute('data-klaviyo-list');
      this.source = form.getAttribute('data-klaviyo-source') || '';
      this.input = form.querySelector('input[type="email"]');
      this.button = form.querySelector('[type="submit"]');
      this.status = form.parentElement.querySelector('[data-klaviyo-status]');
      this.messages = {
        success: form.getAttribute('data-msg-success') || '',
        error: form.getAttribute('data-msg-error') || '',
        invalid: form.getAttribute('data-msg-invalid') || ''
      };
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    setStatus(state, message) {
      if (!this.status) return;
      this.status.textContent = message;
      if (state) {
        this.status.setAttribute('data-state', state);
      } else {
        this.status.removeAttribute('data-state');
      }
    }

    setLoading(isLoading) {
      if (this.button) this.button.disabled = isLoading;
      if (this.input) this.input.disabled = isLoading;
      this.form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    async handleSubmit(event) {
      event.preventDefault();
      const email = (this.input && this.input.value ? this.input.value : '').trim();

      if (!this.isValidEmail(email)) {
        this.setStatus('error', this.messages.invalid);
        return;
      }
      if (!this.company || !this.list) {
        this.setStatus('error', this.messages.error);
        return;
      }

      this.setLoading(true);
      this.setStatus('', '');

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { signup_source: this.source }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: this.list } }
          }
        }
      };

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.company),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-10-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (response.ok || response.status === 202) {
          this.setStatus('success', this.messages.success);
          this.form.reset();
        } else {
          this.setStatus('error', this.messages.error);
        }
      } catch (error) {
        this.setStatus('error', this.messages.error);
      } finally {
        this.setLoading(false);
      }
    }
  }

  function initKlaviyoForms() {
    document.querySelectorAll('[data-klaviyo-subscribe]').forEach((form) => {
      if (form.dataset.klaviyoInit) return;
      form.dataset.klaviyoInit = 'true';
      new KlaviyoSubscribe(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoForms);
  } else {
    initKlaviyoForms();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateHeaderHeight() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    document.documentElement.style.setProperty('--total-header-height', `${header.offsetHeight}px`);
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);

  class HeaderScrollBehavior {
    constructor() {
      this.header = document.querySelector('.header-wrapper');
      if (!this.header) return;

      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.scrollThreshold = 10;
      this.headerHeight = this.header.offsetHeight + 30;

      if (this.header.dataset.stickyBehavior === 'hide_on_scroll') {
        this.init();
      }
    }

    init() {
      window.addEventListener('scroll', () => {
        if (this.ticking) return;

        this.ticking = true;
        requestAnimationFrame(() => {
          this.handleScroll();
          this.ticking = false;
        });
      });
    }

    handleScroll() {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        this.header.classList.remove('header--hidden');
        this.lastScrollY = currentScrollY;
        return;
      }

      if (Math.abs(currentScrollY - this.lastScrollY) < this.scrollThreshold) {
        return;
      }

      const isScrollingDown = currentScrollY > this.lastScrollY;
      const isPastHeader = currentScrollY > this.headerHeight;

      if (isScrollingDown && isPastHeader) {
        this.header.classList.add('header--hidden');
      } else if (!isScrollingDown) {
        this.header.classList.remove('header--hidden');
      }

      this.lastScrollY = currentScrollY;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderScrollBehavior());
  } else {
    new HeaderScrollBehavior();
  }

  (function initMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    const toggleButton = document.getElementById('mobile-menu-toggle');
    const closeButton = document.getElementById('mobile-menu-close');
    const overlay = document.getElementById('mobile-menu-overlay');
    const drawer = menu?.querySelector('.mobile-menu__drawer');

    if (!menu || !toggleButton) return;

    function getFocusableElements() {
      const candidates = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

      // Links inside a collapsed submenu are still in the DOM but cannot take
      // focus, so they must not count as the trap's first/last stop.
      return Array.from(candidates).filter((el) => el.offsetParent !== null);
    }

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggleButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(() => closeButton?.focus(), 100);
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggleButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggleButton.focus();
    }

    function handleKeydown(e) {
      if (!menu.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        closeMenu();
        return;
      }

      if (e.key !== 'Tab') return;

      const focusableElements = getFocusableElements();
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }

    toggleButton.addEventListener('click', openMenu);
    closeButton?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);
    document.addEventListener('keydown', handleKeydown);
  })();

  (function initHeaderDropdowns() {
    const items = document.querySelectorAll('[data-menu-item]');
    if (!items.length) return;

    function setOpen(item, isOpen) {
      item.classList.toggle('is-open', isOpen);
      item.querySelector('[data-menu-trigger]')?.setAttribute('aria-expanded', String(isOpen));
    }

    function closeAll(except) {
      items.forEach((item) => {
        if (item !== except) setOpen(item, false);
      });
    }

    items.forEach((item) => {
      const trigger = item.querySelector('[data-menu-trigger]');
      const panel = item.querySelector('[data-menu-panel]');
      if (!trigger || !panel) return;

      // The panel opens from CSS on hover and focus as well as from .is-open,
      // so ask the computed style rather than tracking every source separately.
      function isPanelVisible() {
        return window.getComputedStyle(panel).visibility === 'visible';
      }

      // Touch devices never fire hover, so the tap has to do the opening. On a
      // mouse it doubles as a way to shut a panel the pointer is still over.
      trigger.addEventListener('click', () => {
        if (isPanelVisible()) {
          setOpen(item, false);
          item.classList.add('is-dismissed');
          return;
        }

        closeAll(item);
        item.classList.remove('is-dismissed');
        setOpen(item, true);
      });

      item.addEventListener('mouseenter', () => {
        if (!item.classList.contains('is-dismissed')) setOpen(item, true);
      });
      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-dismissed');
        if (!item.contains(document.activeElement)) setOpen(item, false);
      });
      item.addEventListener('focusin', () => {
        if (!item.classList.contains('is-dismissed')) setOpen(item, true);
      });
      item.addEventListener('focusout', (event) => {
        if (item.contains(event.relatedTarget)) return;

        item.classList.remove('is-dismissed');
        setOpen(item, false);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const item =
        document.activeElement?.closest('[data-menu-item]') ||
        document.querySelector('[data-menu-item].is-open');
      if (!item) return;

      setOpen(item, false);
      item.classList.add('is-dismissed');
      item.querySelector('[data-menu-trigger]')?.focus();
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-menu-item]')) closeAll();
    });
  })();

  (function initMobileSubmenus() {
    const toggles = document.querySelectorAll('[data-submenu-toggle]');
    if (!toggles.length) return;

    toggles.forEach((toggle) => {
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!isOpen));
        submenu.hidden = isOpen;
      });
    });
  })();

  (function initCartToggle() {
    const toggle = document.getElementById('cart-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
  class HeroProductCarousel {
    constructor(container) {
      this.container = container;
      this.currentIndex = 0;
      this.cards = container.querySelectorAll('[data-product-card]');
      this.images = container.querySelectorAll('[data-hero-images] [data-product-index]');
      this.colorBlock = container.querySelector('[data-color-block]');
      this.prevBtn = container.querySelector('[data-hero-prev]');
      this.nextBtn = container.querySelector('[data-hero-next]');

      if (this.cards.length <= 1) return;

      this.init();
    }

    init() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      const controls = this.container.querySelector('.hero-product__controls');
      if (controls) {
        controls.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prev();
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          }
        });
      }
    }

    goTo(index) {
      const newCard = this.cards[index];
      const bgColor = newCard?.getAttribute('data-card-color') || '#FCD8B3';
      const textColor = newCard?.getAttribute('data-card-text') || '#3E2027';
      const buttonColor = newCard?.getAttribute('data-card-button') || textColor;

      if (this.colorBlock) {
        this.colorBlock.style.backgroundColor = bgColor;
      }

      this.cards.forEach(card => {
        card.style.backgroundColor = bgColor;
        card.style.setProperty('--card-text', textColor);
        card.style.setProperty('--card-button', buttonColor);
      });

      this.cards.forEach(card => card.classList.remove('is-active'));
      this.images.forEach(img => img.classList.remove('is-active'));

      this.cards[index]?.classList.add('is-active');
      this.images.forEach(img => {
        if (img.getAttribute('data-product-index') === String(index)) {
          img.classList.add('is-active');
        }
      });

      this.currentIndex = index;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.cards.length;
      this.goTo(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
      this.goTo(prevIndex);
    }
  }

  function init() {
    const heroSection = document.querySelector('.hero-product');
    if (heroSection) {
      new HeroProductCarousel(heroSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-press"] && !Shopify.designMode) return;
  try {
    
  class PressMarquee {
    constructor() {
      this.sections = Array.from(document.querySelectorAll('.in-press'));
      if (!this.sections.length) return;
      


      this.init();
      this.setupResizeHandler();
    }

    init() {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => requestAnimationFrame(() => this.buildAll()));
      } else {
        requestAnimationFrame(() => this.buildAll());
      }
    }

    buildAll() {
      this.sections.forEach((section) => this.buildMarquee(section));
    }

    buildMarquee(section) {
      const viewport = section.querySelector('.in-press__viewport');
      const track = section.querySelector('[data-press-marquee]');
      const group = track && track.querySelector('.in-press__group');
      if (! viewport || ! track || ! group) return;
      


// Remove existing clones
      track.querySelectorAll('.in-press__group[aria-hidden="true"]').forEach((n) => n.remove());

// Hard reset animation to avoid any snap
      track.classList.remove('is-ready');
      track.style.animation = 'none';
      track.style.transform = 'translate3d(0,0,0)';

// Force reflow
      void track.offsetHeight;

      const viewportWidth = viewport.getBoundingClientRect().width;
      const groupWidth = group.getBoundingClientRect().width;

      if (! groupWidth || ! viewportWidth) return;
      


// Clone until safely longer than viewport (prevents any empty gap)
      let totalWidth = groupWidth;
      const targetWidth = viewportWidth * 3;

      while (totalWidth < targetWidth) {
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        totalWidth += groupWidth;
      }

// Animate by exactly one group width
      const distance = Math.ceil(groupWidth); // ceil helps prevent 1px gaps from rounding
      track.style.setProperty('--marquee-distance', `${distance}px`);

// Constant speed (px/sec)
      const speed = 20;
      const duration = Math.max(20, distance / speed);
      track.style.setProperty('--marquee-duration', `${duration}s`);

// Re-enable animation cleanly
      track.style.animation = '';
      track.classList.add('is-ready');
    }

    setupResizeHandler() {
      let resizeTimer;
      let lastWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth === lastWidth) return;
        lastWidth = newWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.buildAll(), 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new PressMarquee());
  } else {
    new PressMarquee();
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class MainCart {
    constructor() {
      this.cart = document.querySelector('[data-main-cart]');
      this.content = this.cart?.querySelector('[data-cart-content]');
      this.itemsContainer = this.cart?.querySelector('[data-cart-items]');
      this.summary = this.cart?.querySelector('[data-cart-summary]');
      this.countElement = this.cart?.querySelector('[data-cart-item-count]');
      this.itemsLabelElement = this.cart?.querySelector('[data-cart-items-label]');
      this.subtotalElement = this.cart?.querySelector('[data-cart-subtotal]');
      this.emptyElement = this.cart?.querySelector('[data-cart-empty]');
      this.itemSingular = this.cart?.dataset.itemSingular || 'item';
      this.itemPlural = this.cart?.dataset.itemPlural || 'items';

      this.pendingUpdates = new Map();
      this.updateTimeouts = new Map();
      this.inFlightRequests = 0;

      if (!this.cart) return;

      this.bindEvents();
      this.listenForSidecartChanges();
    }

    listenForSidecartChanges() {
      document.addEventListener('cart:updated', () => {
        window.location.reload();
      });
    }

    bindEvents() {
      this.cart.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-action]');
        if (!btn) return;

        const action = btn.dataset.action;
        const key = btn.dataset.key;
        const item = btn.closest('[data-cart-item]');
        const qtyEl = item?.querySelector('[data-quantity]');
        const priceEl = item?.querySelector('[data-price]');
        const comparePriceEl = item?.querySelector('[data-compare-price]');
        const currentQty = parseInt(qtyEl?.value || '1', 10);
        const unitPrice = item?.dataset.unitPrice ? parseInt(item.dataset.unitPrice, 10) : 0;
        const compareUnitPrice = item?.dataset.compareUnitPrice ? parseInt(item.dataset.compareUnitPrice, 10) : 0;

        let newQty = currentQty;

        const inventory = parseInt(item?.dataset.inventory || '99999', 10);
        const inventoryPolicy = item?.dataset.inventoryPolicy || 'deny';

        if (action === 'increase') {
          if (inventoryPolicy === 'deny' && currentQty >= inventory) {
            this.showStockWarning(item, inventory);
            return;
          }
          newQty = currentQty + 1;
        } else if (action === 'decrease') {
          newQty = currentQty > 1 ? currentQty - 1 : 0;
        } else if (action === 'remove') {
          newQty = 0;
        }

        if (newQty === 0) {
          item?.remove();
        } else {
          if (qtyEl) {
            qtyEl.value = newQty;
            qtyEl.defaultValue = newQty;
          }
          if (priceEl && unitPrice) priceEl.textContent = this.formatMoney(unitPrice * newQty);
          if (comparePriceEl && compareUnitPrice) comparePriceEl.textContent = this.formatMoney(compareUnitPrice * newQty);
        }

        this.updateCountsOptimistic(currentQty, newQty, unitPrice);
        this.queueUpdate(key, newQty);
      });

      this.cart.addEventListener('change', (e) => {
        const input = e.target.closest('[data-quantity]');
        if (!input) return;

        const key = input.dataset.key;
        const item = input.closest('[data-cart-item]');
        const priceEl = item?.querySelector('[data-price]');
        const comparePriceEl = item?.querySelector('[data-compare-price]');
        const unitPrice = item?.dataset.unitPrice ? parseInt(item.dataset.unitPrice, 10) : 0;
        const compareUnitPrice = item?.dataset.compareUnitPrice ? parseInt(item.dataset.compareUnitPrice, 10) : 0;

        const oldQty = parseInt(input.defaultValue || '1', 10);
        let newQty = parseInt(input.value || '0', 10);

        if (newQty < 0) newQty = 0;
        input.value = newQty;

        if (newQty === 0) {
          item?.remove();
        } else {
          if (priceEl && unitPrice) priceEl.textContent = this.formatMoney(unitPrice * newQty);
          if (comparePriceEl && compareUnitPrice) comparePriceEl.textContent = this.formatMoney(compareUnitPrice * newQty);
        }

        this.updateCountsOptimistic(oldQty, newQty, unitPrice);
        this.queueUpdate(key, newQty);
        input.defaultValue = newQty;
      });

      const promocodeForm = this.cart.querySelector('.main-cart__promocode');
      if (promocodeForm) {
        promocodeForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const input = promocodeForm.querySelector('.main-cart__promocode-input');
          const code = input?.value?.trim();
          if (code) {
            window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
          }
        });
      }
    }

    queueUpdate(key, quantity) {
      this.pendingUpdates.set(key, quantity);

      if (this.updateTimeouts.has(key)) {
        clearTimeout(this.updateTimeouts.get(key));
      }

      const timeout = setTimeout(() => {
        const finalQty = this.pendingUpdates.get(key);
        this.pendingUpdates.delete(key);
        this.updateTimeouts.delete(key);
        this.updateQuantity(key, finalQty);
      }, 300);

      this.updateTimeouts.set(key, timeout);
    }

    updateCountsOptimistic(oldQty, newQty, unitPrice) {
      const diff = newQty - oldQty;
      const priceDiff = unitPrice * diff;

      if (this.subtotalElement) {
        const currentSubtotal = this.parseMoneyToNumber(this.subtotalElement.textContent);
        this.subtotalElement.textContent = this.formatMoney(currentSubtotal + priceDiff);
      }

      const currentCount = parseInt(document.querySelector('[data-cart-count]')?.textContent || '0', 10);
      const newCount = currentCount + diff;

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = newCount;
      });

      if (this.itemsLabelElement) {
        this.itemsLabelElement.textContent = newCount === 1 ? this.itemSingular : this.itemPlural;
      }

      const itemCountContainer = this.cart?.querySelector('[data-cart-item-count]');
      if (itemCountContainer) {
        itemCountContainer.style.display = newCount > 0 ? '' : 'none';
      }

      if (newCount === 0) {
        this.showEmptyState();
      }
    }

    parseMoneyToNumber(moneyString) {
      const cleaned = moneyString.replace(/[^0-9.,]/g, '').replace(',', '.');
      return Math.round(parseFloat(cleaned) * 100) || 0;
    }

    showEmptyState() {
      if (this.content) {
        this.content.innerHTML = `
          <div class="main-cart__empty" data-cart-empty>
            <h2 class="main-cart__empty-title">${this.cart.dataset.emptyTitle || 'Your cart is empty'}</h2>
            <p class="main-cart__empty-message">${this.cart.dataset.emptyMessage || 'Looks like you haven\'t added anything yet.'}</p>
            <a href="/collections/all" class="main-cart__continue-btn">
              ${this.cart.dataset.continueText || 'Continue shopping'}
            </a>
          </div>
        `;
      }
    }

    showStockWarning(itemEl, actualQty) {
      const warning = itemEl?.querySelector('[data-stock-warning]');
      if (!warning) return;

      const msg = this.cart?.dataset.stockWarning || 'Only COUNT available';
      warning.textContent = msg.replace('COUNT', actualQty);
      warning.hidden = false;

      if (!this.stockWarningTimeouts) this.stockWarningTimeouts = new Map();
      if (this.stockWarningTimeouts.has(itemEl)) {
        clearTimeout(this.stockWarningTimeouts.get(itemEl));
      }

      const timeout = setTimeout(() => {
        warning.hidden = true;
        this.stockWarningTimeouts.delete(itemEl);
      }, 8000);
      this.stockWarningTimeouts.set(itemEl, timeout);
    }

    clearStockWarning(itemEl) {
      const warning = itemEl?.querySelector('[data-stock-warning]');
      if (warning) warning.hidden = true;
    }

    async updateQuantity(key, quantity) {
      this.inFlightRequests++;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });

        const cart = await response.json();
        this.inFlightRequests--;

        if (!response.ok) {
          window.location.reload();
          return;
        }

        const updatedItem = cart.items.find(i => i.key === key);
        const itemEl = this.cart?.querySelector(`[data-cart-item][data-key="${key}"]`);

        if (updatedItem && updatedItem.quantity < quantity) {
          const qtyEl = itemEl?.querySelector('[data-quantity]');
          const priceEl = itemEl?.querySelector('[data-price]');
          const comparePriceEl = itemEl?.querySelector('[data-compare-price]');
          const unitPrice = itemEl?.dataset.unitPrice ? parseInt(itemEl.dataset.unitPrice, 10) : 0;
          const compareUnitPrice = itemEl?.dataset.compareUnitPrice ? parseInt(itemEl.dataset.compareUnitPrice, 10) : 0;

          if (qtyEl) {
            qtyEl.value = updatedItem.quantity;
            qtyEl.defaultValue = updatedItem.quantity;
          }
          if (priceEl && unitPrice) priceEl.textContent = this.formatMoney(unitPrice * updatedItem.quantity);
          if (comparePriceEl && compareUnitPrice) comparePriceEl.textContent = this.formatMoney(compareUnitPrice * updatedItem.quantity);

          this.showStockWarning(itemEl, updatedItem.quantity);
        } else if (itemEl) {
          this.clearStockWarning(itemEl);
        }

        if (this.pendingUpdates.size === 0 && this.inFlightRequests === 0) {
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
          if (this.itemsLabelElement) {
            this.itemsLabelElement.textContent = cart.item_count === 1 ? this.itemSingular : this.itemPlural;
          }
          const itemCountContainer = this.cart?.querySelector('[data-cart-item-count]');
          if (itemCountContainer) {
            itemCountContainer.style.display = cart.item_count > 0 ? '' : 'none';
          }
          if (this.subtotalElement) {
            this.subtotalElement.textContent = this.formatMoney(cart.total_price);
          }

          if (cart.item_count === 0) {
            this.showEmptyState();
          }
        }
      } catch (error) {
        this.inFlightRequests--;
        if (this.pendingUpdates.size === 0 && this.inFlightRequests === 0) {
          window.location.reload();
        }
      }
    }

    formatMoney(cents) {
      const moneyFormat = this.cart?.dataset.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.floor(cents / 100).toString();
      const amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const amountNoDecimalsWithCommas = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return moneyFormat
        .replace('{{amount_with_comma_separator}}', amountWithCommas.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithCommas.replace(/,/g, '.'))
        .replace('{{amount_with_apostrophe_separator}}', amountWithCommas.replace(/,/g, "'"))
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MainCart());
  } else {
    new MainCart();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-your-scents"] && !Shopify.designMode) return;
  try {
    
  class MeetScentsSection extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-tab]');
      this.cards = this.querySelectorAll('[data-card]');
      this.dots = this.querySelectorAll('[data-dot]');
      this.initTabs();
      this.initDots();
    }

    initTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.goTo(index));
        tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
      });
    }

    initDots() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });
    }

    handleKeydown(e, currentIndex) {
      let newIndex = currentIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (currentIndex + 1) % this.tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        newIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        newIndex = this.tabs.length - 1;
      }
      if (newIndex !== currentIndex) {
        this.goTo(newIndex);
        this.tabs[newIndex].focus();
      }
    }

    goTo(index) {
      this.tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.cards.forEach((card, i) => {
        const isActive = i === index;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        card.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      this.currentIndex = index;
    }

  }

  if (!customElements.get('meet-scents-section')) {
    customElements.define('meet-scents-section', MeetScentsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-duo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class BundleDuoSection {
      constructor(section) {
        this.section = section;
        // Exactly one component is customer-picked; the companion is fixed.
        this.bundleSize = 1;
        this.scentPropertyName = 'Scents';
        this.companionPropertyName = 'Wipes';
        this.companionPropertyValue = '';
        this.selections = {};
        this.productData = {};

        this.parseProductData();
        this.initSelectors();
        this.initAccordions();
        this.initIngredientsDialog();
        this.initCartButtons();
      }

      parseProductData() {
        const jsonEl = this.section.querySelector('[data-duo-products]');
        if (jsonEl) {
          try {
            const data = JSON.parse(jsonEl.textContent);
            this.productData = data.scents || {};
            this.bundleVariantId = data.bundleVariantId;
            if (data.scentPropertyName) this.scentPropertyName = data.scentPropertyName;
            if (data.companionPropertyName) this.companionPropertyName = data.companionPropertyName;
            if (data.companionPropertyValue) this.companionPropertyValue = data.companionPropertyValue;
          } catch (e) {
            console.error('Duo bundle: failed to parse product data', e);
          }
        }
      }

      initSelectors() {
        this.selectors = this.section.querySelectorAll('[data-duo-scent-selector]');
        this.selectors.forEach(selector => {
          const trigger = selector.querySelector('.bundle-duo__selector-trigger');
          const options = selector.querySelectorAll('.bundle-duo__selector-option');
          const selectorIndex = selector.getAttribute('data-duo-scent-selector');

          trigger.addEventListener('click', () => this.toggleDropdown(selector));

          options.forEach(option => {
            option.addEventListener('click', () => {
              if (option.getAttribute('aria-disabled') === 'true') return;
              this.selectScent(selector, selectorIndex, option);
            });
          });
        });

        document.addEventListener('click', (e) => {
          if (!e.target.closest('[data-duo-scent-selector]')) {
            this.closeAllDropdowns();
          }
        });

        this.syncDisabledStates();
      }

      toggleDropdown(selector) {
        const trigger = selector.querySelector('.bundle-duo__selector-trigger');
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        this.closeAllDropdowns();

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
        }
      }

      closeAllDropdowns() {
        this.selectors.forEach(s => {
          s.querySelector('.bundle-duo__selector-trigger').setAttribute('aria-expanded', 'false');
        });
      }

      selectScent(selector, selectorIndex, option) {
        const handle = option.getAttribute('data-product-handle');
        let product = this.productData[handle];
        if (!product) {
          const variantId = option.getAttribute('data-variant-id');
          if (!variantId) return;
          product = {
            title: option.getAttribute('data-product-title') || option.textContent.trim(),
            variantId: variantId,
            variantGid: option.getAttribute('data-variant-gid') || ('gid://shopify/ProductVariant/' + variantId),
            cardImage: option.getAttribute('data-card-image') || '',
          };
          this.productData[handle] = product;
        }
        if (!product) return;

        this.selections[selectorIndex] = handle;

        // Only ever reached from a deliberate pick — the pre-rendered default
        // bottle is artwork, not a selection, so it never lands here.
        const label = selector.querySelector('[data-selector-label]');
        label.textContent = product.title;
        selector.classList.add('is-selected');

        option.setAttribute('aria-selected', 'true');
        selector.querySelectorAll('.bundle-duo__selector-option').forEach(opt => {
          if (opt !== option) opt.setAttribute('aria-selected', 'false');
        });

        this.closeAllDropdowns();
        this.syncDisabledStates();
        this.updateBottleImage(selectorIndex, product);
        this.updateButtons();
      }

      syncDisabledStates() {
        this.selectors.forEach(selector => {
          selector.querySelectorAll('.bundle-duo__selector-option').forEach(option => {
            option.setAttribute('aria-disabled', 'false');
          });
        });
      }

      updateBottleImage(selectorIndex, product) {
        const slot = this.section.querySelector('[data-duo-slot="' + selectorIndex + '"]');
        if (!slot) return;

        let img = slot.querySelector('.bundle-duo__bottle-img');
        const placeholder = slot.querySelector('.bundle-duo__bottle-placeholder');

        if (product.cardImage) {
          if (!img) {
            img = document.createElement('img');
            img.className = 'bundle-duo__bottle-img';
            img.loading = 'eager';
            img.width = 800;
            img.height = 800;
            slot.prepend(img);
          }
          img.src = product.cardImage;
          img.alt = product.title;
          img.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
        }
      }

      updateButtons() {
        const allSelected = Object.keys(this.selections).length >= this.bundleSize;
        const canAdd = allSelected;
        const addBtn = this.section.querySelector('[data-duo-add]');
        const buyBtn = this.section.querySelector('[data-duo-buy]');

        if (addBtn) addBtn.disabled = !canAdd;
        if (buyBtn) buyBtn.disabled = !canAdd;
      }

      getSelectedProducts() {
        return Object.entries(this.selections).map(([index, handle]) => {
          const product = this.productData[handle];
          return product ? { index, handle, ...product } : null;
        }).filter(Boolean);
      }

      initCartButtons() {
        const addBtn = this.section.querySelector('[data-duo-add]');
        const buyBtn = this.section.querySelector('[data-duo-buy]');

        if (addBtn) {
          addBtn.addEventListener('click', () => this.addToCart(false));
        }
        if (buyBtn) {
          buyBtn.addEventListener('click', () => this.addToCart(true));
        }
      }

      async addToCart(goToCart) {
        const selected = this.getSelectedProducts().sort((a, b) => Number(a.index) - Number(b.index));
        if (selected.length < this.bundleSize) return;
        if (!this.bundleVariantId) {
          console.error('Duo bundle: no bundle variant ID found');
          return;
        }

        const addBtn = this.section.querySelector('[data-duo-add]');
        const buyBtn = this.section.querySelector('[data-duo-buy]');
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;

        try {
          const formBody = new URLSearchParams();
          formBody.append('id', this.bundleVariantId);
          formBody.append('quantity', '1');

          // Simple Bundles & Kits expands this line into its components (and
          // decrements each component's stock) server-side via its Cart
          // Transform, so both the enhancer and the wipe land on the order as
          // separate line items. It keys off one property per OPTION GROUP,
          // plus a "_bundle_selection" summary, exactly as its own widget
          // submits them.
          //
          // BOTH groups must be sent. The bundle is built in the app's "Manually
          // build" mode, so the wipe is an option group of its own rather than a
          // fixed component — the customer never chooses it (one option), but
          // omitting it leaves that group unresolved and the line will not
          // expand. Group names and values are settings so they can be matched
          // to the app without a code change.
          const scent = selected[0];
          const parts = [];
          if (this.companionPropertyName && this.companionPropertyValue) {
            formBody.append(`properties[${this.companionPropertyName}]`, this.companionPropertyValue);
            parts.push(this.companionPropertyValue);
          }
          formBody.append(`properties[${this.scentPropertyName}]`, scent.title);
          parts.push(scent.title);
          formBody.append('properties[_bundle_selection]', parts.join(' <> '));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formBody
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            console.error('Duo bundle: cart response', response.status, errorData);
            throw new Error('Failed to add to cart');
          }

          if (goToCart) {
            window.location.href = '/cart';
          } else {
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
            document.dispatchEvent(new CustomEvent('cart:open'));
            if (addBtn) addBtn.disabled = false;
            if (buyBtn) buyBtn.disabled = false;
          }
        } catch (error) {
          console.error('Duo bundle: add to cart failed', error);
          if (addBtn) addBtn.disabled = false;
          if (buyBtn) buyBtn.disabled = false;
        }
      }

      initAccordions() {
        const accordions = this.section.querySelectorAll('[data-accordion]');
        accordions.forEach(accordion => {
          const trigger = accordion.querySelector('.bundle-duo__accordion-trigger');
          if (!trigger) return;

          trigger.addEventListener('click', () => {
            const isOpen = accordion.classList.contains('is-open');
            accordion.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', !isOpen);

            const content = accordion.querySelector('.bundle-duo__accordion-content');
            if (content) {
              content.setAttribute('aria-hidden', isOpen);
            }
          });
        });
      }

      initIngredientsDialog() {
        const sectionId = this.section.getAttribute('data-section-id');
        const dialog = this.section.querySelector('#ingredients-dialog-' + sectionId);
        if (!dialog) return;

        const openBtn = this.section.querySelector('[data-open-ingredients]');
        const closeBtn = this.section.querySelector('[data-close-ingredients]');

        if (openBtn) {
          openBtn.addEventListener('click', () => dialog.showModal());
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', () => dialog.close());
        }
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });
      }
    }

    function init() {
      const section = document.querySelector('.bundle-duo');
      if (section) new BundleDuoSection(section);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.bundle-duo')) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class BundleSection {
      constructor(section) {
        this.section = section;
        this.bundleSize = parseInt(section.getAttribute('data-bundle-size')) || 3;
        this.selections = {};
        this.productData = {};

        this.parseProductData();
        this.initSelectors();
        this.initAccordions();
        this.initIngredientsDialog();
        this.initCartButtons();
      }

      parseProductData() {
        const jsonEl = this.section.querySelector('[data-bundle-products]');
        if (jsonEl) {
          try {
            const data = JSON.parse(jsonEl.textContent);
            this.productData = data.scents || {};
            this.bundleVariantId = data.bundleVariantId;
          } catch (e) {
            console.error('Bundle: failed to parse product data', e);
          }
        }
      }

      initSelectors() {
        this.selectors = this.section.querySelectorAll('[data-scent-selector]');
        this.selectors.forEach(selector => {
          const trigger = selector.querySelector('.bundle-main__selector-trigger');
          const options = selector.querySelectorAll('.bundle-main__selector-option');
          const selectorIndex = selector.getAttribute('data-scent-selector');

          trigger.addEventListener('click', () => this.toggleDropdown(selector));

          options.forEach(option => {
            option.addEventListener('click', () => {
              if (option.getAttribute('aria-disabled') === 'true') return;
              this.selectScent(selector, selectorIndex, option);
            });
          });
        });

        document.addEventListener('click', (e) => {
          if (!e.target.closest('[data-scent-selector]')) {
            this.closeAllDropdowns();
          }
        });

        this.syncDisabledStates();
      }

      toggleDropdown(selector) {
        const trigger = selector.querySelector('.bundle-main__selector-trigger');
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        this.closeAllDropdowns();

        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
        }
      }

      closeAllDropdowns() {
        this.selectors.forEach(s => {
          s.querySelector('.bundle-main__selector-trigger').setAttribute('aria-expanded', 'false');
        });
      }

      selectScent(selector, selectorIndex, option) {
        const handle = option.getAttribute('data-product-handle');
        let product = this.productData[handle];
        if (!product) {
          const variantId = option.getAttribute('data-variant-id');
          if (!variantId) return;
          product = {
            title: option.getAttribute('data-product-title') || option.textContent.trim(),
            variantId: variantId,
            variantGid: option.getAttribute('data-variant-gid') || ('gid://shopify/ProductVariant/' + variantId),
            cardImage: option.getAttribute('data-card-image') || '',
          };
          this.productData[handle] = product;
        }
        if (!product) return;

        this.selections[selectorIndex] = handle;

        const label = selector.querySelector('[data-selector-label]');
        label.textContent = selectorIndex + '. ' + product.title;
        selector.classList.add('is-selected');

        option.setAttribute('aria-selected', 'true');
        selector.querySelectorAll('.bundle-main__selector-option').forEach(opt => {
          if (opt !== option) opt.setAttribute('aria-selected', 'false');
        });

        this.closeAllDropdowns();
        this.syncDisabledStates();
        this.updateBottleImage(selectorIndex, product);
        this.updateButtons();
      }

      syncDisabledStates() {
        this.selectors.forEach(selector => {
          selector.querySelectorAll('.bundle-main__selector-option').forEach(option => {
            option.setAttribute('aria-disabled', 'false');
          });
        });
      }

      updateBottleImage(selectorIndex, product) {
        const slot = this.section.querySelector('[data-bottle-slot="' + selectorIndex + '"]');
        if (!slot) return;

        const img = slot.querySelector('.bundle-main__bottle-img');
        const placeholder = slot.querySelector('.bundle-main__bottle-placeholder');

        if (product.cardImage) {
          img.src = product.cardImage;
          img.alt = product.title;
          img.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
        }
      }

      updateButtons() {
        const allSelected = Object.keys(this.selections).length >= this.bundleSize;
        const canAdd = allSelected;
        const addBtn = this.section.querySelector('[data-bundle-add]');
        const buyBtn = this.section.querySelector('[data-bundle-buy]');

        if (addBtn) addBtn.disabled = !canAdd;
        if (buyBtn) buyBtn.disabled = !canAdd;
      }

      getSelectedProducts() {
        return Object.entries(this.selections).map(([index, handle]) => {
          const product = this.productData[handle];
          return product ? { index, handle, ...product } : null;
        }).filter(Boolean);
      }

      initCartButtons() {
        const addBtn = this.section.querySelector('[data-bundle-add]');
        const buyBtn = this.section.querySelector('[data-bundle-buy]');

        if (addBtn) {
          addBtn.addEventListener('click', () => this.addToCart(false));
        }
        if (buyBtn) {
          buyBtn.addEventListener('click', () => this.addToCart(true));
        }
      }

      async addToCart(goToCart) {
        const selected = this.getSelectedProducts().sort((a, b) => Number(a.index) - Number(b.index));
        if (selected.length < this.bundleSize) return;
        if (!this.bundleVariantId) {
          console.error('Bundle: no bundle variant ID found');
          return;
        }

        const addBtn = this.section.querySelector('[data-bundle-add]');
        const buyBtn = this.section.querySelector('[data-bundle-buy]');
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;

        try {
          const formBody = new URLSearchParams();
          formBody.append('id', this.bundleVariantId);
          formBody.append('quantity', '1');

          // Simple Bundles & Kits expands this line into its component scents
          // (and decrements each scent's stock) server-side via its Cart
          // Transform. It keys off the option-group properties ("First Scent",
          // "Second Scent", ...) plus a "_bundle_selection" summary, exactly as
          // its own widget submits them. We replicate that format here so the
          // custom picker drives the same mechanism without the widget.
          const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth'];
          const titles = selected.map(p => p.title);
          selected.forEach((p, i) => {
            const groupName = (ordinals[i] || ('Scent ' + (i + 1))) + ' Scent';
            formBody.append(`properties[${groupName}]`, p.title);
          });
          formBody.append('properties[_bundle_selection]', titles.join(' <> '));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formBody
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            console.error('Bundle: cart response', response.status, errorData);
            throw new Error('Failed to add to cart');
          }

          if (goToCart) {
            window.location.href = '/cart';
          } else {
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
            document.dispatchEvent(new CustomEvent('cart:open'));
            if (addBtn) addBtn.disabled = false;
            if (buyBtn) buyBtn.disabled = false;
          }
        } catch (error) {
          console.error('Bundle: add to cart failed', error);
          if (addBtn) addBtn.disabled = false;
          if (buyBtn) buyBtn.disabled = false;
        }
      }

      initAccordions() {
        const accordions = this.section.querySelectorAll('[data-accordion]');
        accordions.forEach(accordion => {
          const trigger = accordion.querySelector('.bundle-main__accordion-trigger');
          if (!trigger) return;

          trigger.addEventListener('click', () => {
            const isOpen = accordion.classList.contains('is-open');
            accordion.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', !isOpen);

            const content = accordion.querySelector('.bundle-main__accordion-content');
            if (content) {
              content.setAttribute('aria-hidden', isOpen);
            }
          });
        });
      }

      initIngredientsDialog() {
        const sectionId = this.section.getAttribute('data-section-id');
        const dialog = this.section.querySelector('#ingredients-dialog-' + sectionId);
        if (!dialog) return;

        const openBtn = this.section.querySelector('[data-open-ingredients]');
        const closeBtn = this.section.querySelector('[data-close-ingredients]');

        if (openBtn) {
          openBtn.addEventListener('click', () => dialog.showModal());
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', () => dialog.close());
        }
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });
      }
    }

    function init() {
      const section = document.querySelector('.bundle-main');
      if (section) new BundleSection(section);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.bundle-main')) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
class ProductFaq {
  constructor() {
    this.section = document.querySelector('[data-product-faq]');
    if (!this.section) return;

    this.triggers = this.section.querySelectorAll('[data-accordion-trigger]');
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.toggle(trigger));
    });
  }

  toggle(trigger) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    this.triggers.forEach(otherTrigger => {
      if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
        this.close(otherTrigger);
      }
    });

    if (isExpanded) {
      this.close(trigger);
    } else {
      this.open(trigger);
    }
  }

  open(trigger) {
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const item = trigger.closest('[data-accordion-item]');

    trigger.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    item.classList.add('product-faq__item--open');
    content.style.height = content.scrollHeight + 'px';

    content.addEventListener('transitionend', function handler() {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        content.style.height = 'auto';
      }
      content.removeEventListener('transitionend', handler);
    }, { once: true });
  }

  close(trigger) {
    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const item = trigger.closest('[data-accordion-item]');

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;
    trigger.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    item.classList.remove('product-faq__item--open');
    content.style.height = '0';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductFaq());
} else {
  new ProductFaq();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-product-faq]')) {
      new ProductFaq();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  class FeaturesMarquee {
    constructor() {
      this.sections = Array.from(document.querySelectorAll('.product-features'));
      if (!this.sections.length) return;

      this.init();
      this.setupResizeHandler();
    }

    init() {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => requestAnimationFrame(() => this.buildAll()));
      } else {
        requestAnimationFrame(() => this.buildAll());
      }
    }

    buildAll() {
      this.sections.forEach((section) => this.buildMarquee(section));
    }

    buildMarquee(section) {
      const viewport = section.querySelector('.product-features__viewport');
      const track = section.querySelector('[data-features-marquee]');
      const group = track && track.querySelector('.product-features__group');
      if (!viewport || !track || !group) return;

      track.querySelectorAll('.product-features__group[aria-hidden="true"]').forEach((n) => n.remove());

      track.classList.remove('is-ready');
      track.style.animation = 'none';
      track.style.transform = 'translate3d(0,0,0)';

      void track.offsetHeight;

      const viewportWidth = viewport.getBoundingClientRect().width;
      const groupWidth = group.getBoundingClientRect().width;

      if (!groupWidth || !viewportWidth) return;

      let totalWidth = groupWidth;
      const targetWidth = viewportWidth * 3;

      while (totalWidth < targetWidth) {
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        totalWidth += groupWidth;
      }

      const distance = Math.ceil(groupWidth);
      track.style.setProperty('--marquee-distance', `${distance}px`);

      const speed = 25;
      const duration = Math.max(20, distance / speed);
      track.style.setProperty('--marquee-duration', `${duration}s`);

      track.style.animation = '';
      track.classList.add('is-ready');
    }

    setupResizeHandler() {
      let resizeTimer;
      let lastWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        if (newWidth === lastWidth) return;
        lastWidth = newWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.buildAll(), 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new FeaturesMarquee());
  } else {
    new FeaturesMarquee();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('[data-card]');

      if (!this.track || !this.cards.length) return;

      this.setupArrows();
      this.updateArrows();
      this.track.addEventListener('scroll', () => this.updateArrows());
    }

    setupArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scroll(1));
      }
    }

    scroll(direction) {
      const card = this.cards[0];
      if (!card) return;
      const scrollAmount = card.offsetWidth + 20;
      this.track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (this.prevBtn) {
        this.prevBtn.disabled = scrollLeft <= 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    disconnectedCallback() {}
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel {
    constructor(container) {
      this.container = container;
      this.carousel = container.querySelector('.reviews-section__carousel');
      this.track = container.querySelector('[data-reviews-track]');
      this.cardsContainer = container.querySelector('[data-reviews-cards]');
      this.cards = container.querySelectorAll('.reviews-section__card');
      this.prevBtn = container.querySelector('[data-reviews-prev]');
      this.nextBtn = container.querySelector('[data-reviews-next]');
      this.currentIndex = 0;
      this.cardsToShow = this.getCardsToShow();

      if (!this.cardsContainer || this.cards.length === 0) {
        return;
      }

      if (this.cards.length<= this.cardsToShow) {
        this.hideArrows();
        return;
      }

      this.init();
      this.setupResizeHandler();
    }

    init() {
      this.updateCarousel();
      
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
        this.prev();
      })


      


    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
      });
    }

// Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') 
        this.prev();
      


      if (e.key === 'ArrowRight') 
        this.next();
      


    });
  }

  getCardsToShow() {
    const width = window.innerWidth;
    if (width <= 480) return 1;
    if (width <= 768) return 2;
    if (width <= 1200) return 2;
    return 3;
  }

  updateCarousel() {
    if (!this.cardsContainer || this.cards.length === 0) return;
    


    const cardWidth = this.cards[0].offsetWidth;
    const gap = parseFloat(getComputedStyle(this.cardsContainer).gap) || 35;
    const offset = -(this.currentIndex * (cardWidth + gap));

    this.cardsContainer.style.transform = `translateX(${offset}px)`;

// Update button states
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    if (this.nextBtn) {
      const maxIndex = Math.max(0, this.cards.length - this.cardsToShow);
      this.nextBtn.disabled = this.currentIndex >= maxIndex;
    }
  }

  next() {
    const maxIndex = Math.max(0, this.cards.length - this.cardsToShow);
    if (this.currentIndex<maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }

    prev() {
      if (this.currentIndex> 0) {
      this.currentIndex --;
      this.updateCarousel();
    }
  }

  hideArrows() {
    if (this.prevBtn) 
      this.prevBtn.style.display = 'none';
    


    if (this.nextBtn) 
      this.nextBtn.style.display = 'none';
    


  }

  setupResizeHandler() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newCardsToShow = this.getCardsToShow();
        if (newCardsToShow !== this.cardsToShow) {
          this.cardsToShow = newCardsToShow;
          this.currentIndex = Math.min(this.currentIndex, Math.max(0, this.cards.length - this.cardsToShow));
          this.updateCarousel();
        }
      }, 150);
    });
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviews);
} else {
  initReviews();
}

function initReviews () {
  const reviewsSections = document.querySelectorAll('[data-reviews-carousel]');
  reviewsSections.forEach(section => {
    new ReviewsCarousel(section);
  });
}

// Yotpo integration - Load Yotpo script and initialize
(function() {
  const yotpoAppKey = document.querySelector('.yotpo-reviews-carousel') ?. getAttribute('data-appkey');

  if (yotpoAppKey && typeof yotpo === 'undefined') {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `//staticw2.yotpo.com/${yotpoAppKey}/widget.js`;
    document.head.appendChild(script);
  } else if (typeof yotpo !== 'undefined') { // Yotpo already loaded, refresh widgets
    yotpo.refreshWidgets();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidecart"]) return;
  try {
    
class Sidecart {
  constructor() {
    this.sidecart = document.getElementById('sidecart');
    if (!this.sidecart) return;

    this.overlay = document.getElementById('sidecart-overlay');
    this.closeButton = document.getElementById('sidecart-close');
    this.drawer = this.sidecart.querySelector('.sidecart__drawer');

    this.itemSingular = this.sidecart.dataset.itemSingular || 'item';
    this.itemPlural = this.sidecart.dataset.itemPlural || 'items';

    this.shippingBarEnabled = this.sidecart.hasAttribute('data-shipping-bar-enabled');
    this.shippingThreshold = parseInt(this.sidecart.dataset.shippingThreshold || '0', 10);
    this.shippingProgressMsg = this.sidecart.dataset.shippingProgressMsg || '';
    this.shippingSuccessMsg = this.sidecart.dataset.shippingSuccessMsg || '';
    this.shippingCodeMsg = this.sidecart.dataset.shippingCodeMsg || ''; // empty = no code state
    this.shippingCode = null; // the free shipping code in the cart, if any
    this.shippingRacePending = false; // a new code waits for the open drawer to race
    this.shippingProgress = 0; // the bar's real progress (%), where the race starts
    this.drawerReady = false; // the drawer has finished sliding in (see drawerOpened)

    this.triggerElement = null;
    this.stockWarningTimeouts = new Map();

    // --- Cart mutation model -------------------------------------------------
    // Shopify's cart API is not concurrency-safe, and the conditional Buy-X-Get-Y
    // upsell discount (a) splits one variant across several line items at
    // different prices, (b) re-keys every line on any cart change, and (c) makes
    // line prices non-linear. So we never trust line keys or unit*qty math:
    //   - every cart write runs through ONE serialized FIFO chain (no concurrency),
    //   - each write re-reads /cart.js and targets lines by their LIVE 1-based
    //     `line` index, resolved via a variant+properties signature, and
    //   - once the chain drains we re-render the whole drawer from the server.
    // Quantity changes optimistically (instant), but money always reconciles
    // from the authoritative cart because a discount makes it non-linear.
    this.chain = Promise.resolve();
    this.pendingTargets = new Map(); // signature -> desired total quantity
    this.flushTimer = null;
    this.busy = 0; // >0 while any queued job is running
    this.dirty = false; // a real mutation happened since the last render
    this.generation = 0; // bumped on every optimistic change; lets a slow
    // reconcile detect that newer input arrived and skip clobbering it
    this.clamped = new Map(); // signature -> achieved qty when an increase was stock-capped
    this.lastCart = null; // most recent authoritative cart (from a mutation/fetch)
    this.needsStructureRender = false; // a queued op changes the set of cards
    // (add / external update / open) and needs the Liquid section re-render;
    // plain qty/remove only needs a fast in-place money update.
    this.renderRetries = 0; // bounded retries when a structure render's fetch fails
    this.lastCartFresh = false; // lastCart is the cart as it is now (no outside add since)

    // --- Gift with purchase --------------------------------------------------
    // Settings come from the baudie.gift_promo shop metafield (rendered by
    // snippets/gift-promo-data.liquid). Every time the queue drains, syncGifts
    // brings the cart's free gift lines in line with the promo before the
    // drawer renders: it adds earned gifts, removes ones no longer earned, and
    // takes discount codes off while a promo runs. The baudie-discounts
    // function makes the gifts free at checkout from the same settings.
    this.giftPromo = this.readGiftPromo();
    this.giftSynced = true; // cleared by every queued job, so sync runs once per drain
    this.giftBlocked = this.loadBlockedGifts(); // gifts that came out at full price
    this.openOnEmailCode = false; // the load sync opens the drawer for an email link's VIP gift or shipping code
    this.giftChoices = new Map(); // gift value -> the variant picked in the drawer (see pickGiftChoice)
    this.giftChoicesPending = 0; // waiting gift cards showing ("Choose your scent", see renderGiftChoices)
    this.giftChoicePrompted = false; // checkout was clicked before the pick: the cards say so
    this.refocusGift = null; // gift value whose dropdown gets focus back after the render a pick causes
    this.giftWash = null; // the scent wash a pick started, which the new card finishes (see washGift)
    this.preloadedBottles = new Map(); // scent bottle images loading ahead of a pick (see preloadGiftChoices)
    this.checkingOut = false; // checkout clicked, waiting for the cart to settle
    this.giftCardsScroll = 0; // Cards: how far the row is scrolled, kept across re-renders
    this.discountOpen = false; // the discount code fold-out, kept across re-renders
    this.discountMessage = null; // { text, tone } under the code box, kept across renders
    this.pendingDiscountCode = null; // a just-applied code to report on after the render
    this.removingCodes = new Set(); // codes on their way off the cart (their chips already gone)
    this.savedCodes = this.loadSavedCodes(); // codes typed into an empty cart, checked once it holds something (see reportSavedCodes)

    this.cacheRefs();
    this.bindEvents();
    this.initCartListeners();
  }

  cacheRefs() {
    this.content = this.sidecart.querySelector('[data-sidecart-content]');
    this.itemsContainer = this.sidecart.querySelector('[data-sidecart-items]');
    this.footer = this.sidecart.querySelector('[data-sidecart-footer]');
    this.countElement = this.sidecart.querySelector('[data-sidecart-count]');
    this.itemsLabelElement = this.sidecart.querySelector('[data-sidecart-items-label]');
    this.subtotalElement = this.sidecart.querySelector('[data-sidecart-subtotal]');
    this.emptyElement = this.sidecart.querySelector('[data-sidecart-empty]');
    this.shippingBar = this.sidecart.querySelector('[data-shipping-bar]');
    this.shippingBarText = this.sidecart.querySelector('[data-shipping-bar-text]');
    this.shippingBarFill = this.sidecart.querySelector('[data-shipping-bar-fill]');
  }

  // Kept for backwards-compatibility with any external callers.
  refreshElementRefs() {
    this.cacheRefs();
  }

  // ---- Signature + discount helpers --------------------------------------
  // signatureOfLine MUST match the Liquid grouping in this section:
  // variant_id, then `@first=last` for each property, in cart order, then
  // `~sp<id>` for a subscription (selling plan) line.
  //
  // Liquid exposes line-item property keys/values HTML-escaped (e.g. a bundle's
  // "_bundle_selection" value "A <> B" comes through as "A &lt;&gt; B"), and the
  // section writes them into data-properties-signature. /cart.js returns the
  // SAME values raw ("A <> B"). To make both signatures identical we escape the
  // raw API values here the same way Liquid does — otherwise bundle lines (the
  // only ones with <,>,& in a property) never match their card and can't be
  // removed or have their price updated in place.
  htmlEscape(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  signatureOfLine(line) {
    let sig = String(line.variant_id);
    const props = line.properties;
    if (props && typeof props === 'object') {
      Object.keys(props).forEach((k) => {
        sig += '@' + this.htmlEscape(k) + '=' + this.htmlEscape(props[k]);
      });
    }
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
      sig += '~sp' + line.selling_plan_allocation.selling_plan.id;
    }
    return sig;
  }

  isDiscountedLine(line) {
    if (line.total_discount && line.total_discount > 0) return true;
    if (Array.isArray(line.line_level_discount_allocations) && line.line_level_discount_allocations.length > 0) return true;
    const final = typeof line.final_price === 'number' ? line.final_price : line.price;
    const original = typeof line.original_price === 'number' ? line.original_price : line.price;
    return final < original;
  }

  // ---- Event wiring -------------------------------------------------------
  bindEvents() {
    this.closeButton?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => this.handleKeydown(e));
    this.drawer?.addEventListener('transitionend', (e) => {
      if (e.target === this.drawer && e.propertyName === 'transform') this.drawerOpened();
    });
    // Back from checkout (page restored from the back-forward cache): the
    // checkout button works again.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) this.endCheckoutWait();
    });
    // Cards: remember the row's scroll, so a re-render (a gift going in)
    // doesn't send it back to the first card.
    this.sidecart.addEventListener(
      'scroll',
      (e) => {
        if (e.target.matches && e.target.matches('[data-gift-cards]')) this.giftCardsScroll = e.target.scrollLeft;
      },
      true
    );
    this.sidecart.addEventListener('pointerdown', (e) => this.startGiftCardsDrag(e));

    this.sidecart.addEventListener('click', (e) => {
      const checkout = e.target.closest('[data-sidecart-checkout]');
      if (checkout) {
        this.handleCheckoutClick(e, checkout);
        return;
      }
      const emptyCode = e.target.closest('[data-empty-code-open]');
      if (emptyCode) {
        this.discountOpen = true;
        this.renderDiscountState(this.lastCart);
        this.sidecart.querySelector('[data-discount-input]')?.focus();
        return;
      }
      const discountToggle = e.target.closest('[data-discount-toggle]');
      if (discountToggle) {
        this.discountOpen = !this.discountOpen;
        this.renderDiscountState(this.lastCart);
        if (this.discountOpen) this.sidecart.querySelector('[data-discount-input]')?.focus();
        return;
      }
      const removeCode = e.target.closest('[data-discount-remove]');
      if (removeCode) {
        this.removeDiscountCode(removeCode.dataset.discountRemove);
        return;
      }
      const removeGift = e.target.closest('[data-gift-remove]');
      if (removeGift) {
        const card = removeGift.closest('[data-gift]');
        if (card) this.removeGift(card);
        return;
      }
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const item = btn.closest('[data-sidecart-item]');
      if (!item) return;
      this.handleAction(btn.dataset.action, item);
    });

    this.sidecart.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-discount-form]');
      if (!form) return;
      e.preventDefault();
      const input = form.querySelector('[data-discount-input]');
      this.applyDiscountCode((input && input.value ? input.value : '').trim());
    });

    // A gift's scent bottles start loading as its dropdown is reached, so a
    // pick can drop its bottle at once (see dropBottle).
    const preloadBottles = (e) => {
      const wrap = e.target.closest && e.target.closest('[data-gift] .sidecart-item__frequency-wrap');
      const select = wrap && wrap.querySelector('[data-gift-choice-select]');
      if (select) this.preloadGiftChoices(select);
    };
    this.sidecart.addEventListener('pointerover', preloadBottles);
    this.sidecart.addEventListener('focusin', preloadBottles);

    this.sidecart.addEventListener('change', (e) => {
      const frequency = e.target.closest('[data-frequency-select]');
      if (frequency) {
        const card = frequency.closest('[data-sidecart-item]');
        if (card) this.changeFrequency(card, frequency);
        return;
      }

      const giftChoice = e.target.closest('[data-gift-choice-select]');
      if (giftChoice) {
        const card = giftChoice.closest('[data-sidecart-item], [data-gift-pending]');
        if (card) this.chooseGift(card, giftChoice);
        return;
      }

      const input = e.target.closest('[data-quantity]');
      if (!input) return;
      const item = input.closest('[data-sidecart-item]');
      if (!item) return;
      let value = parseInt(input.value || '0', 10);
      if (isNaN(value) || value < 0) value = 0;
      this.setItemQuantity(item, value);
    });
  }

  handleAction(action, item) {
    const input = item.querySelector('[data-quantity]');
    const currentQty = parseInt(input?.value || '1', 10);
    const inventory = parseInt(item.dataset.inventory || '99999', 10);
    const inventoryPolicy = item.dataset.inventoryPolicy || 'deny';

    if (action === 'increase') {
      if (inventoryPolicy === 'deny' && currentQty >= inventory) {
        this.showStockWarning(item, inventory);
        return;
      }
      this.setItemQuantity(item, currentQty + 1);
    } else if (action === 'decrease') {
      this.setItemQuantity(item, currentQty > 1 ? currentQty - 1 : 0);
    } else if (action === 'remove') {
      this.setItemQuantity(item, 0);
    }
  }

  // Optimistic: reflect the new quantity instantly and queue the authoritative
  // write. Per-line price + subtotal are intentionally NOT recomputed here
  // (a Buy-X-Get-Y discount makes them non-linear); they reconcile from the
  // server when the queue drains. The optimistic line price + subtotal use a
  // simple unit*qty estimate (exact when no discount touches the line); the
  // authoritative reconcile corrects any non-linear discount case a moment later.
  setItemQuantity(item, newQty) {
    const signature = item.dataset.propertiesSignature || '';
    const input = item.querySelector('[data-quantity]');
    // defaultValue tracks the last known quantity; input.value may already hold
    // the freshly typed value by the time a `change` event fires.
    const oldQty = parseInt((input && (input.defaultValue || input.value)) || '1', 10);
    const unitPrice = parseInt(item.dataset.unitPrice || '0', 10);

    this.dirty = true;
    this.generation++;

    if (newQty <= 0) {
      // Move focus out before hiding, so a keyboard/screen-reader user who
      // activated Remove isn't dumped onto document.body.
      if (item.contains(document.activeElement)) {
        const others = Array.from(
          this.sidecart.querySelectorAll('[data-sidecart-item]:not([aria-hidden="true"])')
        ).filter((el) => el !== item);
        const focusTarget = (others[0] && others[0].querySelector('[data-action="remove"]')) || this.closeButton;
        focusTarget?.focus();
      }
      item.setAttribute('aria-hidden', 'true');
      item.style.display = 'none';
      this.adjustCountBadge(-oldQty);
      this.adjustSubtotalOptimistic(-unitPrice * oldQty);
      this.pendingTargets.set(signature, 0);
    } else {
      if (input) {
        input.value = newQty;
        input.defaultValue = String(newQty);
      }
      // Scale BOTH the current and the strike-through price together so a
      // discounted line never shows a nonsensical pair. Exact for full-price /
      // regular-sale lines; a close estimate for Buy-X-Get-Y, corrected by the
      // reconcile a moment later.
      const originalUnit = parseInt(item.dataset.originalUnit || String(unitPrice), 10);
      if (unitPrice) this.renderCardPrice(item, newQty, unitPrice * newQty, originalUnit * newQty);
      this.adjustCountBadge(newQty - oldQty);
      this.adjustSubtotalOptimistic(unitPrice * (newQty - oldQty));
      this.pendingTargets.set(signature, newQty);
    }

    this.scheduleFlush();
    this.updateUpsellFromDOM();
  }

  // Optimistically nudge the subtotal + shipping bar by a cent delta, tracking
  // the value in cents to avoid money-string parse/format drift across rapid
  // clicks. The authoritative cart total resets this on the next reconcile.
  adjustSubtotalOptimistic(deltaCents) {
    if (!deltaCents) return;
    if (typeof this.subtotalCents !== 'number') {
      this.subtotalCents = this.parseMoney(this.subtotalElement && this.subtotalElement.textContent);
    }
    this.subtotalCents = Math.max(0, this.subtotalCents + deltaCents);
    if (this.subtotalElement) this.subtotalElement.textContent = this.formatMoney(this.subtotalCents);
    this.updateShippingBar(this.subtotalCents);
    // Gifts are free, so the spend moves with the subtotal until the
    // authoritative cart lands: the last known spend plus the change since.
    const spend = this.lastCart
      ? this.giftSpend(this.lastCart) + (this.subtotalCents - (this.lastCart.total_price || 0))
      : this.subtotalCents;
    this.updateGiftBar(this.lastCart, spend);
    this.previewGiftCards(spend);
  }

  parseMoney(str) {
    const cleaned = (str || '').replace(/[^0-9.,]/g, '').replace(',', '.');
    return Math.round(parseFloat(cleaned) * 100) || 0;
  }

  scheduleFlush() {
    if (this.flushTimer) clearTimeout(this.flushTimer);
    // Short debounce: long enough to coalesce a burst of rapid +/- clicks into
    // one server write, short enough that prices feel responsive.
    this.flushTimer = setTimeout(() => this.flush(), 120);
  }

  flush() {
    if (this.pendingTargets.size === 0) return;
    const targets = new Map(this.pendingTargets);
    this.pendingTargets.clear();
    this.enqueue(async () => {
      for (const [signature, qty] of targets) {
        // A newer action for this signature has already been re-queued; skip
        // this stale one and let the newer target win.
        if (this.pendingTargets.has(signature)) continue;
        try {
          await this.reconcileGroupTo(signature, qty);
        } catch (err) {
          console.error('Sidecart group reconcile failed:', err);
        }
      }
    });
  }

  // Mark that the set of cards may have changed (add / external update / open),
  // so the next drain does a full Liquid re-render. Bumping the generation also
  // invalidates any reconcileRender already in flight (which never bumps it
  // itself), so it bails instead of finishing against the stale pre-change cart
  // and clearing this flag out from under us.
  requestStructureRender() {
    this.needsStructureRender = true;
    this.generation++;
  }

  // Run a job on the serialized chain. The chain itself is kept alive even if a
  // job rejects, but the returned promise rejects so callers (e.g. add-to-cart)
  // can surface errors. A single authoritative re-render runs once the queue
  // fully drains.
  enqueue(job, { giftSync = false } = {}) {
    // Any cart change may earn or lose a gift, so the next drain re-syncs them.
    if (!giftSync) this.giftSynced = false;
    this.busy++;
    const run = this.chain.then(() => job());
    this.chain = run
      .catch((err) => {
        console.error('Sidecart mutation failed:', err);
      })
      .finally(() => {
        this.busy--;
        if (this.busy === 0 && this.pendingTargets.size === 0) {
          // Before rendering, bring the free gifts in line with the cart, once
          // per drain. Queued (not awaited here, which would wait on itself);
          // its own drain then renders.
          if (this.giftPromo && !this.giftSynced) {
            this.giftSynced = true;
            this.enqueue(() => this.syncGifts(), { giftSync: true });
            return;
          }
          // Add / external update / open changes the set of cards -> full Liquid
          // re-render. Plain qty/remove -> fast in-place money update (no extra
          // network: the change.js response cart is already cached in lastCart).
          if (this.needsStructureRender) return this.reconcileRender();
          return this.applyCartMoney(this.lastCart);
        }
      });
    return run;
  }

  async fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();
    this.lastCart = cart;
    this.lastCartFresh = true;
    return cart;
  }

  async changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error('cart/change failed: ' + res.status);
    // change.js returns the full authoritative cart — cache it so we can render
    // money in place without another /cart.js round-trip.
    const cart = await res.json();
    this.lastCart = cart;
    this.lastCartFresh = true;
    return cart;
  }

  // A gift with a choice (the VIP scent gift): picking a scent shows its
  // bottle at once, and the gift sync adds that variant, or swaps the line for
  // it (still free, same `_gift`), so the order carries that scent's own SKU.
  // The dropdown waits until the render that follows has replaced the card,
  // which then gets the focus back if this one had it.
  chooseGift(card, select) {
    const value = card.dataset.gift;
    const variantId = parseInt(select.value, 10);
    if (!value || !variantId || String(variantId) === card.dataset.variantId) return;
    this.giftChoices.set(value, variantId);
    const option = select.selectedOptions[0];
    const image = card.querySelector('.sidecart-item__image');
    if (option && image && option.dataset.image) this.dropBottle(card, image, option.dataset.image);
    const imageLink = card.querySelector('.sidecart-item__image-link');
    if (option && imageLink && option.dataset.cardBg) imageLink.style.backgroundColor = option.dataset.cardBg;
    if (card.contains(document.activeElement)) this.refocusGift = value;
    select.disabled = true; // a disabled select's dropdown doesn't open (assets/select-menu.js)
    if (option) this.washGift(card, option);
    if (option) this.colorGiftChoice(card, option.dataset.textColor);
    card.classList.add('is-choosing');
    card.setAttribute('aria-busy', 'true');
    if (card.hasAttribute('data-gift-pending')) {
      card.setAttribute('data-gift-picked', '');
      const error = card.querySelector('[data-gift-choice-error]');
      if (error) error.hidden = true;
      this.updateGiftChoiceBlock();
    }
    this.requestStructureRender();
    this.enqueue(async () => {});
  }

  // The bottle of the scent wash: the old one (or the waiting card's fan of
  // bottles) falls out of its box, and the picked one drops in from the top
  // once its image can show, so the whole fall is seen. The scents' images load
  // with the fan, or as the dropdown is reached (see preloadGiftChoices), so it
  // usually drops at once.
  dropBottle(card, image, src) {
    let leaving = card.querySelector('.sidecart-item__fan');
    if (leaving) {
      leaving.classList.add('is-leaving');
    } else if (!image.hidden && image.currentSrc) {
      leaving = image.cloneNode();
      leaving.className = 'sidecart-item__leaving sidecart-item__leaving--bottle';
      leaving.alt = '';
      leaving.setAttribute('aria-hidden', 'true');
      image.after(leaving);
    }
    if (leaving) leaving.addEventListener('animationend', () => leaving.remove(), { once: true });
    image.removeAttribute('srcset');
    image.src = src;
    image.hidden = false;
    this.dropIn(image, () => {
      if (this.giftWash && this.giftWash.value === card.dataset.gift) this.giftWash.dropAt = performance.now();
    });
  }

  // Drops a bottle into its box once its image can show (unseen until then).
  dropIn(image, onDrop) {
    image.classList.remove('is-dropping');
    image.classList.add('is-arriving');
    const drop = () => {
      if (!image.isConnected) return;
      image.classList.remove('is-arriving');
      void image.offsetWidth; // restarts the drop
      image.classList.add('is-dropping');
      if (onDrop) onDrop();
    };
    (image.decode ? image.decode() : Promise.resolve()).then(drop, drop);
  }

  // Starts loading a gift's scent bottles (kept, so the loads aren't dropped).
  preloadGiftChoices(select) {
    select.querySelectorAll('option[data-image]').forEach((option) => {
      const src = option.dataset.image;
      if (!src || this.preloadedBottles.has(src)) return;
      const bottle = new Image();
      bottle.src = src;
      this.preloadedBottles.set(src, bottle);
    });
  }

  // The scent wash (see the .is-choosing styles): a wave in the picked scent's
  // product page colors, its darkest leading (the scents' gradients don't all
  // run the same way). It falls back to the scent's card color.
  washGift(card, option) {
    const hex = /^#[0-9a-f]{3}([0-9a-f]{3})?$/i;
    let colors = (option.dataset.wash || '').split(/\s+/).filter((color) => hex.test(color));
    if (colors.length < 3) colors = hex.test(option.dataset.cardBg || '') ? [option.dataset.cardBg] : [];
    if (!colors.length) return;
    const luminance = (color) => {
      const full = color.length === 4 ? color.replace(/[0-9a-f]/gi, '$&$&') : color;
      const [r, g, b] = [1, 3, 5].map((i) => parseInt(full.slice(i, i + 2), 16));
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    const [lead, ...rest] = colors.slice().sort((a, b) => luminance(a) - luminance(b));
    const [fill, tail] = rest.length ? rest.sort((a, b) => luminance(b) - luminance(a)) : [lead, lead];
    // The band's trailing edge, its body (light to mid) and, just ahead, a
    // crest in the darkest color, their edges a gentle wave (a swell and a
    // half down the card); 340 wide for a card of 100.
    const band =
      "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 340 100' preserveAspectRatio='none'>" +
      "<defs><linearGradient id='w' x1='108' x2='226' gradientUnits='userSpaceOnUse'>" +
      `<stop offset='0' stop-color='${fill}'/><stop offset='1' stop-color='${tail}'/></linearGradient></defs>` +
      "<path fill='url(#w)' d='M108 0H226Q230 16.67 226 33.33T226 66.67T226 100H108Q112 83.33 108 66.67T108 33.33T108 0Z'/>" +
      `<path fill='${lead}' d='M226 0Q230 16.67 226 33.33T226 66.67T226 100H236Q240 83.33 236 66.67T236 33.33T236 0Z'/>` +
      '</svg>';
    this.giftWash = {
      value: card.dataset.gift,
      image: `url("data:image/svg+xml,${encodeURIComponent(band)}")`,
      color: tail,
      started: performance.now()
    };
    card.classList.remove('is-chosen');
    card.style.setProperty('--scent-wash', this.giftWash.image);
    card.style.setProperty('--scent-wash-color', this.giftWash.color);
  }

  // The dropdown's box takes the picked scent's product page button color, the
  // old color sliding off to the right (see .is-coloring). The new card has
  // the new color and finishes the slide (see settleGiftWash).
  colorGiftChoice(card, color) {
    const choice = card.querySelector('.sidecart-item__gift-choice');
    const box = choice && (choice.querySelector('.select-menu__button') || choice.querySelector('.sidecart-item__frequency'));
    if (!box || !/^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(color || '')) return;
    const from = getComputedStyle(box).backgroundColor;
    choice.style.setProperty('--scent-box', color);
    choice.style.setProperty('--scent-box-from', from);
    choice.style.removeProperty('--scent-box-delay');
    choice.classList.remove('is-coloring');
    void choice.offsetWidth; // restarts the slide
    choice.classList.add('is-coloring');
    if (this.giftWash && this.giftWash.value === card.dataset.gift) {
      this.giftWash.boxFrom = from;
      this.giftWash.boxAt = performance.now();
    }
  }

  // The render brought the new card: the wave picks up where it was, holds a
  // moment once it covers the card, then runs off.
  settleGiftWash() {
    const wash = this.giftWash;
    this.giftWash = null;
    if (!wash || !this.sidecart.classList.contains('is-open')) return;
    const card = Array.from(this.sidecart.querySelectorAll('[data-gift]')).find(
      (el) => el.dataset.gift === wash.value && el.getAttribute('aria-hidden') !== 'true'
    );
    if (!card || card.classList.contains('is-choosing')) return;
    const elapsed = Math.round(performance.now() - wash.started);
    card.style.setProperty('--scent-wash', wash.image);
    card.style.setProperty('--scent-wash-color', wash.color);
    card.style.setProperty('--scent-wash-elapsed', `${-elapsed}ms`);
    card.style.setProperty('--scent-wash-hold', `${Math.max(550 - elapsed, 0) + 150}ms`);
    card.classList.add('is-chosen');
    // The bottle drops on: the rest of its fall (0.9s, see .is-dropping), or
    // all of it if its image wasn't in yet.
    const image = card.querySelector('.sidecart-item__image');
    const fallen = wash.dropAt ? performance.now() - wash.dropAt : 0;
    if (image && !wash.dropAt) {
      this.dropIn(image);
    } else if (image && fallen < 900) {
      image.style.setProperty('--bottle-delay', `${-Math.round(fallen)}ms`);
      image.classList.add('is-dropping');
    }
    // The box slides on to its new color (0.5s, see .is-coloring).
    const choice = card.querySelector('.sidecart-item__gift-choice');
    const colored = wash.boxAt ? performance.now() - wash.boxAt : Infinity;
    if (choice && colored < 500) {
      choice.style.setProperty('--scent-box-from', wash.boxFrom);
      choice.style.setProperty('--scent-box-delay', `${-Math.round(colored)}ms`);
      choice.classList.add('is-coloring');
    }
    const done = (event) => {
      if (event.target !== card || !/^sidecart-scent-(wash-out|fade)$/.test(event.animationName)) return;
      card.classList.remove('is-chosen');
      card.removeEventListener('animationend', done);
    };
    card.addEventListener('animationend', done);
  }

  // Remove on a VIP gift, or on its card waiting for a scent, takes the gift's
  // code off the cart, like the code's X (see removeDiscountCodes).
  removeGift(card) {
    const row = this.vipRow(card.dataset.gift);
    if (!row) return;
    this.hideGiftCards(card.dataset.gift);
    this.removeDiscountCodes((code) => this.vipRowForCode(code) === row);
  }

  // Takes a gift's cards out of the drawer at once, ahead of the cart, moving
  // the focus off them first.
  hideGiftCards(value) {
    const cards = Array.from(this.sidecart.querySelectorAll('[data-gift]')).filter(
      (card) => card.dataset.gift === value && card.getAttribute('aria-hidden') !== 'true'
    );
    cards.forEach((card) => {
      if (card.contains(document.activeElement)) {
        const others = Array.from(
          this.sidecart.querySelectorAll('[data-sidecart-item]:not([aria-hidden="true"])')
        ).filter((el) => el !== card);
        const focusTarget = (others[0] && others[0].querySelector('[data-action="remove"]')) || this.closeButton;
        focusTarget?.focus();
      }
      card.setAttribute('aria-hidden', 'true');
      card.style.display = 'none';
      const quantity = card.hasAttribute('data-gift-pending')
        ? (this.vipRow(value) || {}).quantity || 1
        : ((this.lastCart && this.lastCart.items) || [])
            .filter((line) => this.isGiftLine(line) && line.properties._gift === value)
            .reduce((sum, line) => sum + line.quantity, 0);
      this.adjustCountBadge(-quantity);
    });
    this.updateGiftChoiceBlock();
  }

  // Switch a card's purchase option: another delivery frequency (selling plan
  // of the same group), one-time -> Subscribe & save, or back to one-time.
  // Optimistic and non-blocking: the dropdown already shows the new value, so
  // the card is retargeted at once and the change is saved in the background
  // with one change.js call per line (by line key, so a stale index can never
  // hit the wrong line). Frequency to frequency updates prices in place via the
  // queue's applyCartMoney. Switching between one-time and subscription changes
  // the label and price treatment, and a merge with another card changes the
  // card set, so those re-render the drawer. On failure the queue re-renders
  // from the real cart and a toast explains.
  changeFrequency(card, select) {
    const oldSignature = card.dataset.propertiesSignature || '';
    if (!oldSignature) return;
    // An empty value is "One-time": null removes the selling plan from the line.
    const sellingPlan = select.value ? parseInt(select.value, 10) : null;
    const base = oldSignature.replace(/~sp\d+$/, '');
    const wasSubscription = base !== oldSignature;
    const newSignature = sellingPlan ? base + '~sp' + sellingPlan : base;
    if (newSignature === oldSignature) return;

    const merges = Array.from(this.sidecart.querySelectorAll('[data-sidecart-item]'))
      .some((other) => other !== card && other.dataset.propertiesSignature === newSignature);
    card.dataset.propertiesSignature = newSignature;
    // Label and price switch optimistically (animated), so only a merge with
    // another card needs a full re-render.
    if (merges) this.requestStructureRender();
    this.animatePurchaseOption(card, select, wasSubscription !== Boolean(sellingPlan) ? Boolean(sellingPlan) : null);
    this.dirty = true;

    this.enqueue(async () => {
      const matching = (cart) => cart.items.filter((line) => this.signatureOfLine(line) === oldSignature);
      let refreshed = !(this.lastCart && matching(this.lastCart).length);
      let cart = refreshed ? await this.fetchCart() : this.lastCart;
      for (let step = 0; step < 10; step++) {
        const lines = matching(cart);
        if (!lines.length) return;
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lines[0].key, quantity: lines[0].quantity, selling_plan: sellingPlan })
        });
        if (!res.ok) {
          // The cached cart may be stale (e.g. its line key changed): retry once fresh.
          if (refreshed) throw new Error('cart/change failed: ' + res.status);
          refreshed = true;
          cart = await this.fetchCart();
          continue;
        }
        const updated = await res.json();
        this.lastCart = updated;
        // Guard against a change that didn't take, so we never loop on it.
        if (matching(updated).length >= lines.length) throw new Error('Selling plan change was not applied');
        cart = updated;
      }
    }).catch(() => {
      card.dataset.propertiesSignature = oldSignature;
      this.showToast(this.sidecart.dataset.frequencyError || 'Could not change the delivery frequency.');
    });
  }

  // The premium bit of switching purchase option, all instant: the arrows spin,
  // the label rolls like an odometer between the nudge and "Subscription", and
  // the price rolls over to the new amount (subtotal + shipping bar follow).
  // toSubscription: true/false when switching type, null for a frequency
  // change (a quick spin only). The server result later confirms or corrects.
  animatePurchaseOption(card, select, toSubscription) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ease = 'cubic-bezier(0.2, 0.8, 0.2, 1)';
    const label = card.querySelector('[data-subscription-label]');
    const icon = label && label.querySelector('svg');
    if (icon && icon.animate && !reduce) {
      const turn = toSubscription === false ? -360 : 360;
      icon.animate(
        [{ transform: 'rotate(0deg)' }, { transform: `rotate(${turn}deg)` }],
        { duration: toSubscription === null ? 700 : 1000, easing: ease }
      );
    }
    if (toSubscription === null) return;

    const dir = toSubscription ? 1 : -1; // roll up into a subscription, down back to one-time

    const box = label && label.querySelector('[data-subscription-text]');
    const text = label && (toSubscription ? label.dataset.textSubscribed : label.dataset.textOneTime);
    if (box && text) {
      Array.from(box.children).slice(0, -1).forEach((el) => el.remove()); // drop a roll still running
      const previous = box.lastElementChild;
      const next = document.createElement('span');
      next.className = 'sidecart-item__subscription-word';
      next.textContent = text;
      box.appendChild(next);
      if (reduce || !next.animate) {
        if (previous) previous.remove();
      } else {
        const timing = { duration: 450, easing: ease, fill: 'both' };
        if (previous) {
          previous
            .animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: `translateY(${-100 * dir}%)`, opacity: 0 }], timing)
            .finished.then(() => previous.remove(), () => {});
        }
        next.animate([{ transform: `translateY(${100 * dir}%)`, opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], timing);
      }
    }

    const option = select.options[select.selectedIndex];
    const unit = parseInt(option && option.dataset.unitPrice, 10);
    if (!Number.isFinite(unit)) return;
    const compareUnit = parseInt(option.dataset.unitCompare || '0', 10) || 0;
    const input = card.querySelector('[data-quantity]');
    const qty = Math.max(parseInt(input && input.value, 10) || 1, 1);
    const previousUnit = parseInt(card.dataset.unitPrice || '0', 10) || 0;
    const update = () => {
      card.dataset.compareAtUnit = String(compareUnit);
      this.renderCardPrice(card, qty, unit * qty, unit * qty);
    };
    this.adjustSubtotalOptimistic((unit - previousUnit) * qty);

    const price = card.querySelector('.sidecart-item__price');
    if (!price || !price.animate || reduce) {
      update();
      return;
    }
    const out = price.animate(
      [{ transform: 'translateY(0)', opacity: 1 }, { transform: `translateY(${-35 * dir}%)`, opacity: 0 }],
      { duration: 160, delay: 80, easing: 'ease-in', fill: 'forwards' }
    );
    out.finished.then(
      () => {
        update();
        out.cancel();
        price.animate(
          [{ transform: `translateY(${35 * dir}%)`, opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 280, easing: ease }
        );
      },
      update
    );
  }

  // Drive a variant+properties group to a target TOTAL quantity. Re-reads the
  // cart each step so it always uses fresh line indices (which shift as the
  // discount re-allocates). Reducing prefers full-price lines so the customer
  // keeps the discounted unit as long as possible.
  //
  // The travel is DIRECTION-LOCKED (only ever increase, or only ever decrease)
  // so a discount that re-allocates on a step can never push us into an
  // increase/decrease oscillation. If the discount makes the exact target
  // unreachable (e.g. a "buy 2 get 1" deal where the in-between total is forced
  // by the rule) or stock caps an increase, we stop at the nearest achievable
  // total instead of thrashing, and flag a stock clamp so the UI can warn.
  async reconcileGroupTo(signature, target) {
    let direction = 0; // -1 decreasing, +1 increasing (set on first read)
    const seen = new Set();
    // Fetch the authoritative cart once to resolve the live line index. After
    // that, each /cart/change.js response IS the next authoritative cart, so we
    // reuse it instead of re-fetching — saving a round-trip on every step.
    let cart = await this.fetchCart();
    for (let guard = 0; guard < 30; guard++) {
      const lines = (cart.items || [])
        .map((line, idx) => ({ line, index: idx + 1 }))
        .filter((x) => this.signatureOfLine(x.line) === signature);

      if (lines.length === 0) return;
      const total = lines.reduce((s, x) => s + x.line.quantity, 0);
      if (total === target) return;

      if (direction === 0) direction = target > total ? 1 : -1;

      // Moved past the target in our travel direction, or revisited a total
      // (no further progress possible) -> accept the nearest achievable total.
      if (direction > 0 && total > target) return;
      if (direction < 0 && total < target) return;
      if (seen.has(total)) {
        if (direction > 0 && total < target) this.clamped.set(signature, total);
        return;
      }
      seen.add(total);

      if (target <= 0) {
        cart = await this.changeLine(lines[0].index, 0);
        continue;
      }

      if (direction > 0) {
        const full = lines.find((x) => !this.isDiscountedLine(x.line)) || lines[0];
        cart = await this.changeLine(full.index, full.line.quantity + (target - total));
      } else {
        const ordered = [
          ...lines.filter((x) => !this.isDiscountedLine(x.line)),
          ...lines.filter((x) => this.isDiscountedLine(x.line))
        ];
        const tgt = ordered[0];
        const reduce = Math.min(total - target, tgt.line.quantity);
        cart = await this.changeLine(tgt.index, tgt.line.quantity - reduce);
      }
    }
  }

  // ---- Authoritative re-render -------------------------------------------
  async reconcileRender() {
    // Snapshot the optimistic-change counter. If the user interacts again
    // during our (network-latency) fetch window, a newer change has been made
    // optimistically and queued; replacing innerHTML now would clobber it back
    // to pre-click state. Bail and let the queued change's own reconcile render.
    const gen = this.generation;
    let cart;
    let html;
    try {
      const cartPromise = this.fetchCart();
      // The section's own id (it lives in a section group): the bare
      // "sidecart" renders with the default settings, not the saved ones.
      const sectionId = encodeURIComponent(this.sidecart.dataset.sectionId || 'sidecart');
      const htmlPromise = fetch('/?section_id=' + sectionId, { cache: 'no-store' }).then((r) => r.text());
      cart = await cartPromise;
      // Update only the count badge early (it lives in the header, which the
      // section render does NOT replace) so it responds the moment the cart
      // lands. Subtotal/shipping/cards all come from the section markup below,
      // so writing them here would be wasted and could show a one-frame
      // count/cards mismatch.
      if (this.generation === gen) this.applyCartCount(cart);
      html = await htmlPromise;
    } catch (e) {
      this.markContentBusy(false);
      // Leave needsStructureRender set and retry shortly (bounded) so a transient
      // fetch failure can't strand a just-added card in the open drawer.
      if (this.needsStructureRender && this.renderRetries < 3) {
        this.renderRetries++;
        setTimeout(() => {
          if (this.needsStructureRender) this.enqueue(async () => {});
        }, 800);
      }
      return;
    }

    if (this.generation !== gen) {
      // Newer optimistic input arrived; leave needsStructureRender set so the
      // queued change's drain retries this render and a newly-added card still
      // appears once interaction settles.
      this.markContentBusy(false);
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('[data-sidecart-content]');
    const newFooter = doc.querySelector('[data-sidecart-footer]');
    const openMenu = this.openMenuKey();
    if (newContent && this.content) this.content.innerHTML = newContent.innerHTML;
    if (newFooter && this.footer) this.footer.innerHTML = newFooter.innerHTML;

    // The top bar stays put while it shows a free shipping code, so its race
    // and glow run on through re-renders (applyCartTotals sets its text and
    // width).
    const topBar = this.sidecart.querySelector('.sidecart__drawer > [data-shipping-bar]');
    const newTopBar = doc.querySelector('.sidecart__drawer > [data-shipping-bar]');
    if (topBar && newTopBar && !topBar.classList.contains('sidecart__shipping-bar--code')) {
      topBar.innerHTML = newTopBar.innerHTML;
      topBar.className = newTopBar.className;
    }

    this.cacheRefs();
    this.applyCartTotals(cart);
    this.applyUpsellVisibility(this.upsellProductIds(cart));
    this.surfaceClamps();
    this.reportPendingDiscount(cart);
    this.reportSavedCodes(cart);
    this.restoreGiftFocus();
    this.settleGiftWash();
    this.reopenMenu(openMenu);
    this.needsStructureRender = false;
    this.renderRetries = 0;
    this.markContentBusy(false);

    // Notify other components (e.g. the main cart page) of real cart changes.
    // Tagged fromSidecart so our own listener ignores it, and only fired when a
    // mutation actually happened (never on a plain open/reconcile).
    if (this.dirty) {
      this.dirty = false;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, fromSidecart: true } }));
    }
  }

  // The dropdown open in the drawer (a scent or a purchase option), as its
  // card and kind, so a render that rebuilds the card can open it again.
  openMenuKey() {
    const menu = this.content && this.content.querySelector('select-menu.is-open');
    const card = menu && menu.closest('[data-sidecart-item], [data-gift-pending]');
    const select = menu && menu.querySelector('select');
    if (!card || !select) return null;
    return {
      signature: card.dataset.propertiesSignature || null,
      gift: card.dataset.gift || null,
      select: select.hasAttribute('data-gift-choice-select') ? '[data-gift-choice-select]' : '[data-frequency-select]',
      focused: menu.contains(document.activeElement)
    };
  }

  // A render rebuilt the card whose dropdown was open (e.g. the one that
  // follows opening the drawer): it opens again on the new card, in the same
  // frame, so it never shuts under the customer's hand.
  reopenMenu(key) {
    if (!key || !this.sidecart.classList.contains('is-open')) return;
    const card = Array.from(this.sidecart.querySelectorAll('[data-sidecart-item], [data-gift-pending]')).find(
      (el) =>
        el.getAttribute('aria-hidden') !== 'true' &&
        (key.signature ? el.dataset.propertiesSignature === key.signature : el.dataset.gift === key.gift)
    );
    const menu = card && card.querySelector(key.select)?.closest('select-menu');
    if (!menu || !menu.button || menu.isOpen) return;
    if (key.focused) menu.button.focus({ preventScroll: true });
    menu.open();
  }

  // After a scent is picked, the render replaces the card whose dropdown had
  // the focus: it goes to the new card's dropdown, unless it has moved on.
  restoreGiftFocus() {
    const value = this.refocusGift;
    this.refocusGift = null;
    if (!value || !this.sidecart.classList.contains('is-open')) return;
    const active = document.activeElement;
    if (active && active !== document.body && this.sidecart.contains(active)) return;
    const card = Array.from(this.sidecart.querySelectorAll('[data-gift]')).find(
      (el) => el.dataset.gift === value && el.getAttribute('aria-hidden') !== 'true'
    );
    if (card) this.giftChoiceControl(card)?.focus({ preventScroll: true });
  }

  // Warn on any group whose increase the server could not fully honour (stock
  // capped), recorded by reconcileGroupTo. Runs after the cards are re-rendered.
  surfaceClamps() {
    if (this.clamped.size === 0) return;
    const esc = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : s);
    this.clamped.forEach((qty, signature) => {
      let card = null;
      try {
        card = this.sidecart.querySelector('[data-sidecart-item][data-properties-signature="' + esc(signature) + '"]');
      } catch (e) {
        card = null;
      }
      if (card) this.showStockWarning(card, qty);
    });
    this.clamped.clear();
  }

  // Fast path for qty/remove: update money + quantities in place from the
  // authoritative cart the mutation already returned — no /cart.js fetch and no
  // Liquid section re-render. A qty change never creates a NEW card (a discount
  // split merges into the same signature group), so only updates and removals
  // are needed here; new cards go through reconcileRender instead.
  applyCartMoney(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      // No cached cart to render from — fall back to an authoritative render.
      this.needsStructureRender = true;
      return this.reconcileRender();
    }

    const groups = new Map();
    cart.items.forEach((line) => {
      const sig = this.signatureOfLine(line);
      const g = groups.get(sig) || { qty: 0, final: 0, original: 0 };
      g.qty += line.quantity;
      g.final += line.final_line_price;
      g.original += line.original_line_price;
      groups.set(sig, g);
    });

    // Safety: if the cart gained a group that has no card (unexpected for a
    // qty/remove, e.g. a discount auto-added a product), the card set changed —
    // fall back to a full Liquid render so the new card is shown.
    const cardSigs = new Set(
      Array.from(this.sidecart.querySelectorAll('[data-sidecart-item]')).map((c) => c.dataset.propertiesSignature)
    );
    for (const sig of groups.keys()) {
      if (!cardSigs.has(sig)) {
        this.needsStructureRender = true;
        return this.reconcileRender();
      }
    }

    this.sidecart.querySelectorAll('[data-sidecart-item]').forEach((card) => {
      const g = groups.get(card.dataset.propertiesSignature);
      if (!g) {
        card.remove();
        return;
      }
      // Re-show if a card was optimistically hidden by a remove that the server
      // ultimately kept (its group still exists).
      card.style.display = '';
      card.removeAttribute('aria-hidden');
      const input = card.querySelector('[data-quantity]');
      if (input) {
        input.value = g.qty;
        input.defaultValue = String(g.qty);
      }
      this.renderCardPrice(card, g.qty, g.final, g.original);
    });

    this.cacheRefs();
    this.applyCartTotals(cart);
    this.applyUpsellVisibility(this.upsellProductIds(cart));
    this.surfaceClamps();
    this.reportPendingDiscount(cart);
    this.markContentBusy(false);

    if (this.dirty) {
      this.dirty = false;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, fromSidecart: true } }));
    }
  }

  // Update one merged card's price display. Mirrors the price logic in
  // snippets/sidecart-item.liquid exactly, toggling the pre-rendered stable
  // markup rather than rebuilding it.
  renderCardPrice(card, qty, final, original) {
    const compareAtUnit = parseInt(card.dataset.compareAtUnit || '0', 10);
    let hasCompare = false;
    let compare = 0;
    if (original > final) {
      hasCompare = true;
      compare = original;
    } else if (compareAtUnit > 0 && compareAtUnit * qty > final) {
      hasCompare = true;
      compare = compareAtUnit * qty;
    }

    // Keep the per-unit prices fresh so the next optimistic estimate is accurate.
    if (qty > 0) {
      card.dataset.unitPrice = Math.round(final / qty);
      card.dataset.originalUnit = Math.round(original / qty);
    }

    const currentEl = card.querySelector('[data-price]');
    const priceAmount = card.querySelector('[data-price-amount]');
    const saleLabel = card.querySelector('[data-sale-label]');
    const compareEl = card.querySelector('[data-compare-price]');
    const compareAmount = card.querySelector('[data-compare-amount]');

    if (priceAmount) {
      priceAmount.textContent =
        card.dataset.gift !== undefined && final === 0 && card.dataset.freeText
          ? card.dataset.freeText
          : this.formatMoney(final);
    }
    if (currentEl) currentEl.classList.toggle('sidecart-item__current-price--sale', hasCompare);
    if (saleLabel) saleLabel.hidden = !hasCompare;
    if (compareEl) compareEl.hidden = !hasCompare;
    if (hasCompare && compareAmount) compareAmount.textContent = this.formatMoney(compare);
  }

  // Count badge only (header + any [data-cart-count] outside the drawer). These
  // survive the section innerHTML replace, so they're safe to update early.
  // A gift waiting for its scent shows as a card, so it counts too.
  applyCartCount(cart) {
    const count =
      (cart.item_count || 0) +
      this.pendingGiftChoices(cart).reduce((sum, gift) => sum + (gift.row.quantity || 1), 0);
    if (this.countElement) this.countElement.textContent = count;
    this.updateItemsLabel(count);
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  applyCartTotals(cart) {
    this.renderGiftChoices(cart);
    this.applyCartCount(cart);
    this.trackShippingCode(cart);
    if (typeof cart.total_price === 'number') {
      this.subtotalCents = cart.total_price; // authoritative; resets optimistic drift
      if (this.subtotalElement) this.subtotalElement.textContent = this.formatMoney(cart.total_price);
      this.updateShippingBar(cart.total_price);
    }
    this.updateGiftBar(cart);
    this.renderDiscountState(cart);
    if ((cart.item_count || 0) === 0 && !this.giftChoicesPending) {
      this.showEmptyState();
    } else {
      this.hideEmptyState();
    }
    if (this.shippingRacePending) this.raceShippingBar();
  }

  adjustCountBadge(diff) {
    if (!diff) return;
    const current = parseInt(this.countElement?.textContent || '0', 10);
    const next = Math.max(0, current + diff);
    if (this.countElement) this.countElement.textContent = next;
    this.updateItemsLabel(next);
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = next;
      el.style.display = next > 0 ? '' : 'none';
    });
    if (next === 0) this.showEmptyState();
  }

  markContentBusy(isBusy) {
    this.sidecart.classList.toggle('is-loading', !!isBusy);
  }

  updateShippingBar(cartTotalCents) {
    if (!this.shippingBarEnabled || !this.shippingBarText || !this.shippingBarFill) return;

    const threshold = this.shippingThreshold;
    const remaining = Math.max(0, threshold - cartTotalCents);
    const progress = threshold > 0 ? Math.min(100, (cartTotalCents / threshold) * 100) : 0;
    this.shippingProgress = progress;

    // A free shipping code fills the bar whatever the total, in the scents'
    // rainbow (see the --code styles).
    const code = this.shippingCode;
    if (this.shippingBar) this.shippingBar.classList.toggle('sidecart__shipping-bar--code', !!code);
    if (code) {
      this.shippingBarFill.style.width = '100%';
      this.shippingBarText.textContent = this.shippingCodeMsg;
      return;
    }

    this.shippingBarFill.style.width = progress + '%';

    if (remaining <= 0) {
      this.shippingBarText.textContent = this.shippingSuccessMsg;
    } else {
      this.shippingBarText.textContent = this.shippingProgressMsg.replace('[amount]', this.formatMoney(remaining));
    }
  }

  // The free shipping code in the cart, or null. Shipping is only priced at
  // checkout, so a shipping code applies (applicable) but discounts nothing
  // here, while every other code that applies shows on a line or the cart.
  freeShippingCode(cart) {
    const used = new Set();
    (cart.cart_level_discount_applications || []).forEach((app) => used.add(String(app.title || '').toUpperCase()));
    (cart.items || []).forEach((line) => {
      (line.discounts || []).forEach((discount) => used.add(String(discount.title || '').toUpperCase()));
    });
    const entry = (cart.discount_codes || []).find(
      (discount) => discount.applicable && !used.has(String(discount.code || '').toUpperCase())
    );
    return entry ? entry.code : null;
  }

  // A free shipping code that's new to the cart races the bar once the drawer
  // shows it: typed in the drawer, or from an email link (which opens the
  // drawer, see syncGifts). The raced code is remembered in this browser so a
  // page load doesn't race it again (or reopen the drawer for it); taking the
  // code off forgets it, so adding it back races again.
  trackShippingCode(cart) {
    const code = this.shippingCodeMsg ? this.freeShippingCode(cart) : null;
    const key = String(code || '').toUpperCase();
    let raced = null;
    try {
      raced = localStorage.getItem('baudie:shipping-race');
      if (!code && raced) localStorage.removeItem('baudie:shipping-race');
    } catch (e) {}
    if (!code) {
      this.shippingRacePending = false;
    } else if (key !== String(this.shippingCode || '').toUpperCase() && key !== raced) {
      this.shippingRacePending = true;
    }
    this.shippingCode = code;
  }

  // The truck races from the real progress to the end while the rainbow forms
  // behind it (the --race styles). Waits until the drawer has slid all the way
  // in and the bar shows the code (drawn by applyCartTotals: until then the
  // re-render would still replace the bar and cut the race): drawerOpened and
  // the next applyCartTotals call it again.
  raceShippingBar() {
    const bar = this.shippingBar;
    const fill = this.shippingBarFill;
    if (!bar || !fill || !this.shippingCode) return;
    if (!this.drawerReady || bar.classList.contains('sidecart__shipping-bar--hidden')) return;
    if (!bar.classList.contains('sidecart__shipping-bar--code')) return;
    this.shippingRacePending = false;
    try {
      localStorage.setItem('baudie:shipping-race', String(this.shippingCode).toUpperCase());
    } catch (e) {}
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    fill.style.transition = 'none';
    fill.style.width = this.shippingProgress + '%';
    void fill.offsetWidth; // the race starts there, not at 100%
    fill.style.transition = '';
    bar.classList.add('sidecart__shipping-bar--race');
    fill.style.width = '100%';
    clearTimeout(this.shippingRaceTimer);
    this.shippingRaceTimer = setTimeout(() => bar.classList.remove('sidecart__shipping-bar--race'), 1600);
  }

  showEmptyState() {
    this.cacheRefs();
    if (this.itemsContainer) this.itemsContainer.classList.add('sidecart__items--hidden');
    if (this.emptyElement) this.emptyElement.classList.remove('sidecart__empty--hidden');
    if (this.footer) this.footer.classList.add('sidecart__footer--hidden');
    if (this.shippingBar) this.shippingBar.classList.add('sidecart__shipping-bar--hidden');
    const upsellRegion = this.sidecart.querySelector('[data-sidecart-upsell]');
    if (upsellRegion) upsellRegion.hidden = true;
    this.placeDiscountBox();
  }

  hideEmptyState() {
    this.cacheRefs();
    if (this.itemsContainer) this.itemsContainer.classList.remove('sidecart__items--hidden');
    if (this.emptyElement) this.emptyElement.classList.add('sidecart__empty--hidden');
    if (this.footer) this.footer.classList.remove('sidecart__footer--hidden');
    if (this.shippingBar) this.shippingBar.classList.remove('sidecart__shipping-bar--hidden');
    this.placeDiscountBox();
  }

  // The footer (and the code box in it) is hidden while the cart is empty, so
  // a customer with a code but no items, like a VIP who didn't use the email
  // link, opens the box with "Have a code?" and it moves under "Continue
  // shopping". It stays there while open or holding a code, and goes back
  // above the subtotal once the cart holds something. A render brings a fresh
  // box in the footer, which this moves again.
  placeDiscountBox(cart = this.lastCart) {
    const box = this.sidecart.querySelector('[data-sidecart-discount]');
    const slot = this.sidecart.querySelector('[data-empty-code]');
    if (!box || !slot) return;
    const empty = !!this.emptyElement && !this.emptyElement.classList.contains('sidecart__empty--hidden');
    const hasCodes = ((cart && cart.discount_codes) || []).some(
      (entry) => !this.removingCodes.has(String(entry.code).toUpperCase())
    );
    const inEmpty = empty && (this.discountOpen || hasCodes);
    if (inEmpty && box.parentElement !== slot) {
      slot.appendChild(box);
    } else if (!inEmpty && box.parentElement === slot && this.footer) {
      this.footer.insertBefore(box, this.footer.querySelector('.sidecart__subtotal-row'));
    }
    const open = slot.querySelector('[data-empty-code-open]');
    if (open) open.hidden = inEmpty && this.discountOpen;
  }

  updateItemsLabel(count) {
    if (this.itemsLabelElement) {
      this.itemsLabelElement.textContent = count === 1 ? this.itemSingular : this.itemPlural;
    }
  }

  // ---- Cart event listeners ----------------------------------------------
  initCartListeners() {
    document.addEventListener('cart:open', () => this.open());
    document.addEventListener('cart:updated', (e) => {
      // Ignore the events we dispatch ourselves; reconcile for external ones
      // (e.g. the product-bundle add path), which may add a card -> full render.
      if (e.detail && e.detail.fromSidecart) return;
      this.lastCartFresh = false;
      this.requestStructureRender();
      this.enqueue(async () => {});
    });
    this.updateUpsell();
    this.initGiftPromo();
  }

  // ---- Upsell visibility --------------------------------------------------
  applyUpsellVisibility(productIds) {
    const region = this.sidecart.querySelector('[data-sidecart-upsell]');
    if (!region) return;

    if (productIds.length === 0) {
      region.hidden = true;
      return;
    }

    // A cart of only deal products gets no deal (it needs a regular product
    // too), so offering another one at the deal price would be misleading.
    const dealIds = (region.dataset.dealIds || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

    const onlyDeals = dealIds.length > 0 && productIds.every((id) => dealIds.includes(id));
    if (onlyDeals) {
      region.hidden = true;
      return;
    }

    let anyVisible = false;
    region.querySelectorAll('[data-sidecart-upsell-offer]').forEach((offer) => {
      // A bundle that contains this offer arrives as ONE line item: Simple
      // Bundles expands it at checkout, so the component's product id never
      // appears in /cart.js. Treat "a bundle containing it is in the cart" as
      // equivalent to the offer itself being in the cart, or we upsell the
      // customer something they have already bought.
      const containedIn = (offer.dataset.containedIn || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      const inCart =
        productIds.includes(String(offer.dataset.productId)) ||
        containedIn.some((id) => productIds.includes(id));
      offer.hidden = inCart;
      if (!inCart) anyVisible = true;
    });

    region.hidden = !anyVisible;
  }

  // Instant: reads the cart line cards already in the drawer DOM (ignores cards
  // optimistically removed). Final truth comes from reconcileRender.
  updateUpsellFromDOM() {
    // Free gifts don't count as "already in the cart": the customer didn't pick them.
    const items = this.sidecart.querySelectorAll('[data-sidecart-item]:not([aria-hidden="true"]):not([data-gift])');
    const productIds = Array.from(items)
      .map((el) => String(el.dataset.productId))
      .filter((id) => id && id !== 'undefined');
    this.applyUpsellVisibility(productIds);
  }

  // Authoritative: reconciles upsell visibility against the live cart.
  async updateUpsell() {
    if (!this.sidecart.querySelector('[data-sidecart-upsell]')) return;
    let cart;
    try {
      cart = await this.fetchCart();
    } catch (e) {
      return;
    }
    this.applyUpsellVisibility(this.upsellProductIds(cart));
  }

  // Product ids the upsell treats as "in the cart". Free gifts are left out:
  // the customer didn't choose them, so they shouldn't hide an offer.
  upsellProductIds(cart) {
    return (cart.items || []).filter((line) => !this.isGiftLine(line)).map((line) => String(line.product_id));
  }

  // ---- Gift with purchase -------------------------------------------------
  readGiftPromo() {
    const el = this.sidecart.querySelector('[data-gift-promo]');
    if (!el) return null;
    try {
      const promo = JSON.parse(el.textContent);
      promo.tiers = (promo.tiers || []).filter((tier) => tier.variantId);
      promo.vip = (promo.vip || []).filter((row) => row.variantId && row.prefix);
      return promo;
    } catch (e) {
      console.error('Sidecart gift settings unreadable:', e);
      return null;
    }
  }

  initGiftPromo() {
    if (!this.giftPromo) return;
    // A VIP gift added by this first sync, or a new free shipping code it
    // finds, came from an email link (/discount/CODE): the drawer opens to
    // show it.
    this.openOnEmailCode = true;
    // ?gift_preview=1 (the admin's preview link) makes this browser's cart a
    // preview cart, so a promo in Preview runs for it; ?gift_preview=0 undoes it.
    const flag = new URLSearchParams(window.location.search).get('gift_preview');
    if (flag === '1' || flag === '0') {
      this.enqueue(async () => {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _gift_preview: flag === '1' ? '1' : '' } })
        });
        if (res.ok) {
          this.lastCart = await res.json();
          this.lastCartFresh = true;
        }
      });
      return;
    }
    // Otherwise sync once on load: e.g. a VIP code applied by an email link
    // (/discount/CODE), or a promo that started since the cart was filled.
    this.enqueue(async () => {});
  }

  isGiftLine(line) {
    return !!(line && line.properties && line.properties._gift);
  }

  isVipGiftValue(value) {
    return String(value || '').indexOf('vip:') === 0;
  }

  giftKey(value, variantId) {
    return value + '|' + variantId;
  }

  // The VIP row of a gift value ("vip:<prefix>"), or null.
  vipRow(value) {
    if (!this.giftPromo || !this.isVipGiftValue(value)) return null;
    return this.giftPromo.vip.find((vip) => 'vip:' + vip.prefix === value) || null;
  }

  // The VIP row a discount code belongs to (its code starts with the row's
  // prefix), or null.
  vipRowForCode(code) {
    const upper = String(code || '').toUpperCase();
    return this.giftPromo.vip.find((vip) => upper.indexOf(String(vip.prefix).toUpperCase()) === 0) || null;
  }

  // True for a gift the customer picks the variant of in the drawer: a VIP
  // gift whose product has several (the scent gift; see pickGiftChoice).
  giftHasChoice(value) {
    const row = this.vipRow(value);
    return !!(row && row.choices);
  }

  // A gift that came out at full price stays off for the rest of the visit, so
  // a misconfigured gift can never loop. Reset whenever the settings are saved.
  loadBlockedGifts() {
    try {
      const saved = JSON.parse(sessionStorage.getItem('baudie:gift-blocked') || 'null');
      if (saved && this.giftPromo && saved.version === this.giftPromo.updatedAt) return new Set(saved.keys);
    } catch (e) {}
    return new Set();
  }

  blockGift(key) {
    this.giftBlocked.add(key);
    try {
      sessionStorage.setItem(
        'baudie:gift-blocked',
        JSON.stringify({ version: this.giftPromo.updatedAt, keys: Array.from(this.giftBlocked) })
      );
    } catch (e) {}
  }

  // The store's date (YYYY-MM-DD) in its own time zone, like the function's
  // shop.localTime.date.
  storeToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: this.giftPromo.timezone || undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  // Mirrors giftPromoIsRunning in the baudie-discounts function.
  giftPromoRunning(cart) {
    const promo = this.giftPromo;
    if (!promo || !promo.tiers.length) return false;
    if (promo.status === 'preview') {
      return !!(cart && cart.attributes && cart.attributes._gift_preview === '1');
    }
    if (promo.status !== 'on') return false;
    const today = this.storeToday();
    if (promo.startDate && today < promo.startDate) return false;
    if (promo.endDate && today > promo.endDate) return false;
    return true;
  }

  // What the customer is spending: every line except gifts, after discounts
  // (the wipes deal, subscription prices).
  giftSpend(cart) {
    return (cart.items || [])
      .filter((line) => !this.isGiftLine(line))
      .reduce((sum, line) => sum + (line.final_line_price || 0), 0);
  }

  // A tier's spend amount in the cart's currency, in cents.
  giftTierCents(tier) {
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    return Math.round(parseFloat(tier.minimum) * 100 * rate);
  }

  // The gift lines the cart should have, keyed by their `_gift` value:
  // "tier:N" for each spend tier reached (promo running), or "vip:<prefix>" for
  // a VIP code in the cart (no promo running: codes are blocked during one).
  desiredGifts(cart) {
    const desired = new Map();
    const promo = this.giftPromo;
    const want = (value, gift) => {
      const variantId = gift.choices ? this.pickGiftChoice(value, gift, cart) : gift.available && gift.variantId;
      if (!variantId || this.giftBlocked.has(this.giftKey(value, variantId))) return;
      desired.set(value, { variantId, quantity: gift.quantity || 1 });
    };

    if (this.giftPromoRunning(cart)) {
      const spend = this.giftSpend(cart);
      promo.tiers.forEach((tier, index) => {
        if (spend >= this.giftTierCents(tier)) want('tier:' + (index + 1), tier);
      });
    } else {
      (cart.discount_codes || []).forEach((entry) => {
        const row = this.vipRowForCode(entry.code);
        if (row) want('vip:' + row.prefix, row);
      });
    }
    return desired;
  }

  // The variants a gift with a choice can be: in stock and not blocked.
  usableGiftChoices(value, gift) {
    if (this.giftBlocked.has(this.giftKey(value, '*'))) return [];
    return gift.choices
      .filter((choice) => choice.available && !this.giftBlocked.has(this.giftKey(value, choice.variantId)))
      .map((choice) => choice.variantId);
  }

  // The variant a gift with a choice should be, if it's usable: the one
  // picked in the drawer, else the one already in the cart. Nothing is picked
  // for the customer: until they pick, the gift waits in the drawer
  // ("Choose your scent", see pendingGiftChoices).
  pickGiftChoice(value, gift, cart) {
    const usable = this.usableGiftChoices(value, gift);
    const usableId = (id) => (usable.includes(id) ? id : null);
    const line = (cart.items || []).find((item) => this.isGiftLine(item) && item.properties._gift === value);
    return usableId(this.giftChoices.get(value)) || usableId(line && line.variant_id) || null;
  }

  // The VIP gifts waiting for the customer to pick (the scent gift): the
  // gift's code is in the cart, but the gift isn't, as nothing is picked yet
  // (or the pick didn't go in). Each with the codes that bring it and the
  // variants it can still be. None while a promo runs (no codes then).
  pendingGiftChoices(cart) {
    if (!this.giftPromo || !cart || this.giftPromoRunning(cart)) return [];
    const pending = new Map();
    (cart.discount_codes || []).forEach((entry) => {
      const row = this.vipRowForCode(entry.code);
      if (!row || !row.choices) return;
      const value = 'vip:' + row.prefix;
      if (!pending.has(value)) pending.set(value, { value, row, codes: [], usable: this.usableGiftChoices(value, row) });
      pending.get(value).codes.push(String(entry.code));
    });
    return Array.from(pending.values()).filter(
      (gift) =>
        gift.usable.length > 0 &&
        !(cart.items || []).some((line) => this.isGiftLine(line) && line.properties._gift === gift.value)
    );
  }

  // Puts in a card for each gift waiting for a pick (from its template, see
  // snippets/sidecart-gift-choice.liquid) and takes out the ones no longer
  // waiting, after every render. The drawer opens for a waiting gift once
  // (see syncGifts), so it remembers here which codes it has shown.
  renderGiftChoices(cart) {
    const pending = this.pendingGiftChoices(cart);
    const values = new Set(pending.map((gift) => gift.value));
    this.sidecart.querySelectorAll('[data-gift-pending]').forEach((card) => {
      if (!values.has(card.dataset.gift)) card.remove();
    });
    pending.forEach((gift) => {
      const cards = Array.from(this.sidecart.querySelectorAll('[data-gift-pending]'));
      if (cards.some((card) => card.dataset.gift === gift.value)) return;
      const template = Array.from(this.sidecart.querySelectorAll('template[data-gift-choice-template]')).find(
        (el) => el.dataset.giftChoiceTemplate === gift.value
      );
      const source = template && template.content.firstElementChild;
      if (!source || !this.itemsContainer) return;
      const card = document.importNode(source, true);
      // Scents sold out or blocked since the page loaded aren't offered.
      card.querySelectorAll('[data-gift-choice-select] option').forEach((option) => {
        if (option.value && !gift.usable.includes(parseInt(option.value, 10))) option.remove();
      });
      const error = card.querySelector('[data-gift-choice-error]');
      if (error) error.hidden = !this.giftChoicePrompted;
      this.itemsContainer.appendChild(card); // its dropdown sets itself up as it goes in
    });
    if (!pending.length) this.giftChoicePrompted = false;
    this.giftChoicesPending = this.sidecart.querySelectorAll('[data-gift-pending]:not([aria-hidden="true"])').length;
    this.updateGiftChoiceBlock();

    try {
      if (!pending.length) {
        localStorage.removeItem('baudie:gift-choice-shown');
      } else if (this.sidecart.classList.contains('is-open')) {
        localStorage.setItem('baudie:gift-choice-shown', this.giftChoiceCodes(pending).join(','));
      }
    } catch (e) {}
  }

  giftChoiceCodes(pending) {
    return pending.flatMap((gift) => gift.codes.map((code) => code.toUpperCase()));
  }

  // True when a waiting gift has a code this browser hasn't shown yet: the
  // drawer opens for it (an email link's code, see syncGifts).
  newGiftChoice(cart) {
    let shown = [];
    try {
      shown = (localStorage.getItem('baudie:gift-choice-shown') || '').split(',');
    } catch (e) {}
    return this.giftChoiceCodes(this.pendingGiftChoices(cart)).some((code) => !shown.includes(code));
  }

  // The first waiting gift card with nothing picked yet, or null.
  unpickedGiftChoice() {
    return this.sidecart.querySelector('[data-gift-pending]:not([data-gift-picked]):not([aria-hidden="true"])');
  }

  // Checkout waits while a gift waits for its pick: dimmed, and a click asks
  // for the pick (see handleCheckoutClick). The footer is re-rendered, so the
  // state lives on the drawer.
  updateGiftChoiceBlock() {
    const waiting = !!this.unpickedGiftChoice();
    this.sidecart.classList.toggle('is-gift-choice-pending', waiting);
    this.sidecart.querySelectorAll('[data-sidecart-checkout]').forEach((link) => {
      if (waiting) link.setAttribute('aria-disabled', 'true');
      else link.removeAttribute('aria-disabled');
    });
  }

  // Checkout clicked before the pick: brings the waiting card into view with
  // its message ("Choose your scent to check out.") and a nudge, and puts the
  // focus on its dropdown. The message stays on through re-renders until the
  // pick.
  promptGiftChoice() {
    const card = this.unpickedGiftChoice() || this.sidecart.querySelector('[data-gift-pending]');
    this.giftChoicePrompted = true;
    if (!card) return;
    const error = card.querySelector('[data-gift-choice-error]');
    if (error) error.hidden = false;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    card.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    card.classList.remove('is-prompted');
    void card.offsetWidth; // so the nudge plays again on another click
    card.classList.add('is-prompted');
    this.giftChoiceControl(card)?.focus({ preventScroll: true });
  }

  // A gift card's dropdown to focus: the styled button, or the native select
  // when the dropdown script hasn't set it up (it comes first in the card).
  giftChoiceControl(card) {
    return card.querySelector('.select-menu__button') || card.querySelector('[data-gift-choice-select]');
  }

  // Runs on the chain once per drain (see enqueue). Each step re-reads the live
  // cart, so line indices are always current.
  async syncGifts() {
    const openOnEmailCode = this.openOnEmailCode;
    this.openOnEmailCode = false;
    try {
      let cart = this.lastCartFresh && this.lastCart ? this.lastCart : await this.fetchCart();
      let changed = false;
      let addedVip = false;

      // A VIP gift's pick goes with its code: adding the code back asks again.
      const coded = new Set();
      (cart.discount_codes || []).forEach((entry) => {
        const row = this.vipRowForCode(entry.code);
        if (row) coded.add('vip:' + row.prefix);
      });
      Array.from(this.giftChoices.keys()).forEach((value) => {
        if (!coded.has(value)) this.giftChoices.delete(value);
      });

      // 1. No discount codes while a promo runs (checkout rejects them too).
      if (this.giftPromoRunning(cart) && (cart.discount_codes || []).length) {
        cart = await this.updateCartDiscounts([]);
        this.setDiscountMessage(this.codesBlockedMessage(), 'error');
        changed = true;
      }

      // 2. Remove gift lines that aren't earned (or are duplicates) and fix
      // quantities, all in one request.
      const fixes = this.giftFixes(cart);
      if (Object.keys(fixes).length) {
        cart = await this.updateLines(fixes);
        changed = true;
      }

      // 3. Add the earned gifts that are missing, in one request.
      const missing = this.missingGifts(cart);
      if (missing.length) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: missing })
        });
        if (!res.ok) {
          // E.g. a gift sold out since the page loaded: leave those out.
          missing.forEach((item) => this.blockGift(this.giftKey(item.properties._gift, item.id)));
        } else {
          addedVip = missing.some((item) => this.isVipGiftValue(item.properties._gift));
        }
        cart = await this.fetchCart();
        changed = true;
      }

      // 4. Safety net: a gift must be free. One that isn't (the discount is
      // switched off, a VIP code doesn't cover that product, ...) is removed
      // rather than charged. A gift with a choice is blocked whole, since the
      // code would miss its other variants too.
      const charged = {};
      (cart.items || []).forEach((line) => {
        if (!this.isGiftLine(line) || line.final_line_price <= 0) return;
        const value = line.properties._gift;
        this.blockGift(this.giftKey(value, this.giftHasChoice(value) ? '*' : line.variant_id));
        charged[line.key] = 0;
      });
      if (Object.keys(charged).length) {
        cart = await this.updateLines(charged);
        changed = true;
      }

      if (changed) {
        this.dirty = true;
        this.needsStructureRender = true;
      }

      // Show the customer what their email link just brought: the VIP gift it
      // added (unless step 4 took it back off), a VIP gift waiting for them to
      // pick its scent (once per code, so browsing on doesn't keep opening
      // it), or a free shipping code new to this browser. That one waits for
      // something in the cart: an empty cart's drawer opens on the first add
      // instead, and the bar races once the drawer is in.
      if (openOnEmailCode && !this.sidecart.classList.contains('is-open')) {
        const vipGift =
          addedVip &&
          (cart.items || []).some((line) => this.isGiftLine(line) && this.isVipGiftValue(line.properties._gift));
        this.trackShippingCode(cart);
        if (vipGift || this.newGiftChoice(cart) || (this.shippingRacePending && (cart.item_count || 0) > 0)) {
          this.open();
        }
      }
    } catch (err) {
      console.error('Sidecart gift sync failed:', err);
    }
  }

  // The fixes the existing gift lines need, as /cart/update.js updates keyed by
  // line key ({} when every gift line is right): 0 for a gift that isn't
  // earned or is a duplicate, otherwise its quantity when that's off.
  giftFixes(cart) {
    const desired = this.desiredGifts(cart);
    const seen = new Set();
    const updates = {};
    (cart.items || []).forEach((line) => {
      if (!this.isGiftLine(line)) return;
      const value = line.properties._gift;
      const want = desired.get(value);
      if (!want || want.variantId !== line.variant_id || seen.has(value)) {
        updates[line.key] = 0;
        return;
      }
      seen.add(value);
      if (line.quantity !== want.quantity) updates[line.key] = want.quantity;
    });
    return updates;
  }

  // Several lines in one request, by line key (a gift and a paid line of the
  // same product are separate lines, so variant ids won't do).
  async updateLines(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error('cart/update failed: ' + res.status);
    const cart = await res.json();
    this.lastCart = cart;
    this.lastCartFresh = true;
    return cart;
  }

  // True when the cart's gift lines don't match what it earns: one to remove
  // or fix, one missing, or one that isn't free.
  giftsOutOfSync(cart) {
    return (
      Object.keys(this.giftFixes(cart)).length > 0 ||
      this.missingGifts(cart).length > 0 ||
      (cart.items || []).some((line) => this.isGiftLine(line) && line.final_line_price > 0)
    );
  }

  // Optimistic, while a quantity change is on its way: hide the gift cards the
  // new spend no longer earns (and take them off the item count, which shows
  // the empty cart if nothing else is left), so a gift never lingers while the
  // sync removes it. A spend that climbs back shows them again; the next
  // render shows the real cart either way. VIP gifts don't depend on spend.
  previewGiftCards(spend) {
    if (!this.giftPromo || !this.lastCart || !this.giftPromoRunning(this.lastCart)) return;
    const earned = new Set();
    this.giftPromo.tiers.forEach((tier, index) => {
      if (spend >= this.giftTierCents(tier)) earned.add('tier:' + (index + 1));
    });
    this.sidecart.querySelectorAll('[data-sidecart-item][data-gift^="tier:"]').forEach((card) => {
      const leaving = !earned.has(card.dataset.gift);
      if (leaving === card.hasAttribute('data-gift-leaving')) return;
      // Already hidden for another reason: leave it be.
      if (leaving && card.getAttribute('aria-hidden') === 'true') return;
      const quantity = (this.lastCart.items || [])
        .filter((line) => this.isGiftLine(line) && line.properties._gift === card.dataset.gift)
        .reduce((sum, line) => sum + line.quantity, 0);
      card.toggleAttribute('data-gift-leaving', leaving);
      if (leaving) {
        card.setAttribute('aria-hidden', 'true');
        card.style.display = 'none';
      } else {
        card.removeAttribute('aria-hidden');
        card.style.display = '';
      }
      this.adjustCountBadge(leaving ? -quantity : quantity);
    });
  }

  missingGifts(cart) {
    const present = new Set(
      (cart.items || []).filter((line) => this.isGiftLine(line)).map((line) => line.properties._gift)
    );
    const missing = [];
    this.desiredGifts(cart).forEach((gift, value) => {
      if (!present.has(value)) {
        missing.push({ id: gift.variantId, quantity: gift.quantity, properties: { _gift: value } });
      }
    });
    return missing;
  }

  // Progress toward the gifts, for however many tiers the promo has (1, 2 or
  // 3), as a list or a segmented bar (the Gift progress style setting).
  // Hidden unless a promo runs for this cart and it has paid items.
  updateGiftBar(cart, spendOverride) {
    const bar = this.sidecart.querySelector('[data-gift-bar]');
    if (!bar) return;
    const running = !!cart && this.giftPromoRunning(cart);
    let hasItems = !!cart && (cart.items || []).some((line) => !this.isGiftLine(line));
    // Optimistic update (the cart is the one before the change): go by the
    // cards still showing, so removing the last item hides it straight away.
    if (hasItems && typeof spendOverride === 'number') {
      hasItems = !!this.sidecart.querySelector('[data-sidecart-item]:not([aria-hidden="true"]):not([data-gift])');
    }
    if (!running || !hasItems) {
      bar.hidden = true;
      return;
    }

    const tiers = this.giftPromo.tiers
      .map((tier, index) => ({
        cents: this.giftTierCents(tier),
        label: (tier.quantity > 1 ? tier.quantity + ' × ' : '') + tier.title,
        value: 'tier:' + (index + 1),
        image: tier.image,
        cardBg: tier.cardBg,
        worth: tier.worth,
        // Same test as desiredGifts: a gift that won't be added isn't offered.
        offered: tier.available && !this.giftBlocked.has(this.giftKey('tier:' + (index + 1), tier.variantId))
      }))
      .sort((a, b) => a.cents - b.cents);
    const spend = typeof spendOverride === 'number' ? spendOverride : this.giftSpend(cart);

    if (bar.dataset.giftLayout === 'list') {
      bar.hidden = !this.updateGiftList(bar, tiers, spend);
    } else if (bar.dataset.giftLayout === 'cards') {
      bar.hidden = !this.updateGiftCards(bar, tiers, spend);
      const row = bar.querySelector('[data-gift-cards][data-restore-scroll]');
      if (row && !bar.hidden) {
        delete row.dataset.restoreScroll;
        row.scrollLeft = this.giftCardsScroll;
      }
    } else {
      this.updateGiftSteps(bar, tiers, spend);
      bar.hidden = false;
    }
  }

  // List layout: a row per gift on offer, numbered in spend order. Each row is
  // unlocked (a tick, FREE), the next gift (tinted) or still ahead, with the
  // spend it unlocks at and what's left. The rows are rebuilt only when the
  // gifts on offer change (a gift sold out at page load or blocked since).
  // Returns false when there's no gift to show.
  updateGiftList(bar, tiers, spend) {
    const list = bar.querySelector('[data-gift-list]');
    if (!list) return false;
    const shown = tiers.filter((tier) => tier.offered);
    const signature = shown.map((tier) => tier.cents + ':' + tier.label).join('|');
    if (list.dataset.gifts !== signature) {
      list.dataset.gifts = signature;
      list.replaceChildren(
        ...shown.map((tier, index) => {
          const row = document.createElement('li');
          row.className = 'sidecart__gift-row';
          row.innerHTML =
            '<span class="sidecart__gift-row-icon" aria-hidden="true">' +
            '<span class="sidecart__gift-row-number"></span>' +
            '<svg class="sidecart__gift-row-check" focusable="false" viewBox="0 0 10 10" fill="none"><path d="M2 5.3L4.1 7.3L8 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</span>' +
            '<span class="sidecart__gift-row-info">' +
            '<span class="sidecart__gift-row-name"></span><span class="sidecart__gift-row-status"></span>' +
            '</span>' +
            '<span class="sidecart__gift-row-value"></span>';
          row.querySelector('.sidecart__gift-row-number').textContent = index + 1;
          row.querySelector('.sidecart__gift-row-name').textContent = tier.label;
          return row;
        })
      );
    }

    let unlockedCount = 0;
    let currentFound = false;
    Array.from(list.children).forEach((row, index) => {
      const tier = shown[index];
      const unlocked = spend >= tier.cents;
      const current = !unlocked && !currentFound;
      if (current) currentFound = true;
      if (unlocked) unlockedCount += 1;
      row.classList.toggle('is-unlocked', unlocked);
      row.classList.toggle('is-current', current);
      row.querySelector('.sidecart__gift-row-status').textContent = unlocked
        ? bar.dataset.unlockedMsg || ''
        : (bar.dataset.unlocksAtMsg || '').replace('AMOUNT', this.formatMoney(tier.cents).replace(/[.,]00(?=\D*$)/, ''));
      row.querySelector('.sidecart__gift-row-value').textContent = unlocked
        ? bar.dataset.freeMsg || ''
        : (bar.dataset.leftMsg || '').replace('AMOUNT', this.formatMoney(tier.cents - spend));
    });

    // "2 of 3 unlocked". A single gift's row says it all.
    const count = bar.querySelector('[data-gift-list-count]');
    if (count) {
      count.textContent =
        shown.length > 1
          ? (bar.dataset.countMsg || '').replace('COUNT', unlockedCount).replace('TOTAL', shown.length)
          : '';
    }
    return shown.length > 0;
  }

  // Cards layout: a card per gift on offer, in spend order, rebuilt only when
  // the gifts on offer change (or the drawer re-renders, which replaces them:
  // the row goes back to where the customer had scrolled it). Each shows its
  // own progress toward its spend amount, then what's left to spend or, once
  // unlocked, Added to cart (the sync adds it). Returns false when there's no
  // gift to show.
  updateGiftCards(bar, tiers, spend) {
    const list = bar.querySelector('[data-gift-cards]');
    if (!list) return false;
    const shown = tiers.filter((tier) => tier.offered);
    const signature = shown.map((tier) => tier.value + ':' + tier.cents).join('|');
    const noDecimals = (cents) => this.formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');
    if (list.dataset.gifts !== signature) {
      list.dataset.gifts = signature;
      list.replaceChildren(
        ...shown.map((tier) => {
          const card = document.createElement('li');
          card.className = 'sidecart__gift-card';
          card.dataset.giftCard = tier.value;
          card.innerHTML =
            '<div class="sidecart__gift-card-top">' +
            '<span class="sidecart__gift-card-image" aria-hidden="true"></span>' +
            '<span class="sidecart__gift-card-text">' +
            '<span class="sidecart__gift-card-name"></span><span class="sidecart__gift-card-detail"></span>' +
            '</span>' +
            '</div>' +
            '<div class="sidecart__gift-card-track" aria-hidden="true"><div class="sidecart__gift-card-fill"></div></div>' +
            '<p class="sidecart__gift-card-chip" data-gift-card-locked></p>' +
            '<p class="sidecart__gift-card-chip sidecart__gift-card-chip--added" data-gift-card-added hidden>' +
            // The gift icon of the gift lines' "Gift with purchase".
            '<svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
            '<path d="M1.25 3.75H10.75V6.25H1.25V3.75ZM2.25 6.25V10.75H9.75V6.25M6 3.75V10.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M6 3.75C5.6 2.2 4.9 1.25 4 1.25C3.3 1.25 2.9 1.7 2.9 2.3C2.9 3.1 3.7 3.75 6 3.75ZM6 3.75C6.4 2.2 7.1 1.25 8 1.25C8.7 1.25 9.1 1.7 9.1 2.3C9.1 3.1 8.3 3.75 6 3.75Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
            '</svg>' +
            '<span></span></p>';
          const image = card.querySelector('.sidecart__gift-card-image');
          if (tier.cardBg) image.style.backgroundColor = tier.cardBg;
          if (tier.image) {
            const img = document.createElement('img');
            img.src = tier.image;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 52;
            img.height = 52;
            img.draggable = false;
            image.appendChild(img);
          }
          card.querySelector('.sidecart__gift-card-name').textContent = tier.label;
          card.querySelector('.sidecart__gift-card-detail').textContent = (bar.dataset.detailMsg || '')
            .replace('WORTH', noDecimals(tier.worth || 0))
            .replace('AMOUNT', noDecimals(tier.cents));
          card.querySelector('[data-gift-card-added] span').textContent = bar.dataset.addedMsg || '';
          return card;
        })
      );
      // Scrolled back once the panel shows (see updateGiftBar): a hidden row can't scroll.
      list.dataset.restoreScroll = '';
    }

    let unlockedCount = 0;
    Array.from(list.children).forEach((card, index) => {
      const tier = shown[index];
      const unlocked = spend >= tier.cents;
      if (unlocked) unlockedCount += 1;
      card.classList.toggle('is-unlocked', unlocked);
      const fill = card.querySelector('.sidecart__gift-card-fill');
      if (fill) fill.style.width = (tier.cents > 0 ? Math.min(1, Math.max(0, spend / tier.cents)) : 1) * 100 + '%';
      const locked = card.querySelector('[data-gift-card-locked]');
      locked.hidden = unlocked;
      if (!unlocked) locked.textContent = (bar.dataset.lockedMsg || '').replace('AMOUNT', this.formatMoney(tier.cents - spend));
      card.querySelector('[data-gift-card-added]').hidden = !unlocked;
    });

    // "2 of 3 unlocked". A single gift's card says it all.
    const count = bar.querySelector('[data-gift-list-count]');
    if (count) {
      count.textContent =
        shown.length > 1
          ? (bar.dataset.countMsg || '').replace('COUNT', unlockedCount).replace('TOTAL', shown.length)
          : '';
    }
    return shown.length > 0;
  }

  // Cards: click and drag the row with a mouse (touch screens swipe it
  // natively, so only the mouse is handled). Snapping is off while dragging;
  // on release the row glides to the nearest card and snapping comes back.
  startGiftCardsDrag(e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    const row = e.target.closest('[data-gift-cards]');
    if (!row || row.scrollWidth <= row.clientWidth) return;
    e.preventDefault(); // no text selection or image dragging
    const startX = e.clientX;
    const startScroll = row.scrollLeft;
    let dragging = false;
    const move = (ev) => {
      const dx = ev.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 4) return;
        dragging = true;
        row.classList.add('is-dragging');
      }
      row.scrollLeft = startScroll - dx;
    };
    const end = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
      if (!dragging) return;
      const rowLeft = row.getBoundingClientRect().left;
      const padding = parseFloat(getComputedStyle(row).scrollPaddingLeft) || 0;
      const max = row.scrollWidth - row.clientWidth;
      const stops = Array.from(row.children).map((card) =>
        Math.min(max, Math.max(0, row.scrollLeft + card.getBoundingClientRect().left - rowLeft - padding))
      );
      const target = stops.reduce(
        (best, stop) => (Math.abs(stop - row.scrollLeft) < Math.abs(best - row.scrollLeft) ? stop : best),
        stops[0] || 0
      );
      row.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(() => row.classList.remove('is-dragging'), 450);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  }

  // Bar layout: a message, then one segment per tier, each filling from the
  // previous tier's amount to its own, with the gift and its amount underneath.
  updateGiftSteps(bar, tiers, spend) {
    // The segments are built once: the bar lives outside the re-rendered
    // regions, and the tiers only change with a page load.
    const steps = bar.querySelector('[data-gift-steps]');
    if (steps && !steps.children.length) {
      tiers.forEach((tier) => {
        const step = document.createElement('div');
        step.className = 'sidecart__gift-step';
        step.innerHTML =
          '<div class="sidecart__gift-step-track" aria-hidden="true"><div class="sidecart__gift-step-fill"></div></div>' +
          '<p class="sidecart__gift-step-label">' +
          '<span class="sidecart__gift-step-icon" aria-hidden="true">' +
          '<svg class="sidecart__gift-step-check" focusable="false" viewBox="0 0 8 8" fill="none"><path d="M1.5 4.2L3.2 5.8L6.5 2.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span><span class="sidecart__gift-step-name"></span></p>' +
          '<p class="sidecart__gift-step-amount"></p>';
        step.querySelector('.sidecart__gift-step-name').textContent = tier.label;
        step.querySelector('.sidecart__gift-step-amount').textContent = this.formatMoney(tier.cents).replace(/[.,]00(?=\D*$)/, '');
        steps.appendChild(step);
      });
    }

    let previous = 0;
    let currentFound = false;
    Array.from(steps ? steps.children : []).forEach((step, index) => {
      const tier = tiers[index];
      if (!tier) return;
      const span = tier.cents - previous;
      const progress = span > 0 ? Math.min(1, Math.max(0, (spend - previous) / span)) : 1;
      const unlocked = spend >= tier.cents;
      const current = !unlocked && !currentFound;
      if (current) currentFound = true;
      step.classList.toggle('is-unlocked', unlocked);
      step.classList.toggle('is-current', current);
      const fill = step.querySelector('.sidecart__gift-step-fill');
      if (fill) fill.style.width = progress * 100 + '%';
      previous = tier.cents;
    });

    const text = bar.querySelector('[data-gift-bar-text]');
    const next = tiers.find((tier) => spend < tier.cents);
    if (text) {
      text.textContent = next
        ? (bar.dataset.progressMsg || '')
            .replace('[amount]', this.formatMoney(next.cents - spend))
            .replace('[gift]', next.label)
        : bar.dataset.successMsg || '';
    }
  }

  // ---- Checkout -----------------------------------------------------------
  // Checkout waits for the cart to settle. A quantity change still on its way,
  // or the gift sync after it, would otherwise reach checkout with gifts the
  // cart no longer earns, which checkout charges at full price. While a gift
  // promo is set up, the gifts are also checked once more against the live
  // cart (it may have changed in another tab). New-tab clicks go straight
  // through, unless a gift waits for its scent: then no click goes through
  // until it's picked.
  handleCheckoutClick(e, link) {
    if (this.unpickedGiftChoice()) {
      e.preventDefault();
      this.promptGiftChoice();
      return;
    }
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (this.checkingOut) return;
    this.goToCheckout(link.href);
  }

  async goToCheckout(href) {
    this.checkingOut = true;
    this.sidecart.classList.add('is-checking-out');
    try {
      // A quantity change still in its debounce goes out now.
      if (this.pendingTargets.size) {
        clearTimeout(this.flushTimer);
        this.flush();
      }
      await this.cartSettled();
      if (this.giftPromo && this.giftsOutOfSync(await this.fetchCart())) {
        await this.enqueue(() => this.syncGifts(), { giftSync: true });
        await this.cartSettled();
      }
      // A gift still waits for its scent: one picked just now didn't go in
      // (it sold out meanwhile), or the code came in from another tab.
      if (this.pendingGiftChoices(this.lastCart).length) {
        this.endCheckoutWait();
        this.promptGiftChoice();
        return;
      }
    } catch (err) {
      console.error('Sidecart checkout check failed:', err);
    }
    window.location.href = href;
    // Still here a while later (navigation cancelled): let them try again.
    setTimeout(() => this.endCheckoutWait(), 8000);
  }

  endCheckoutWait() {
    this.checkingOut = false;
    this.sidecart.classList.remove('is-checking-out');
  }

  // Resolves once no cart write, debounced quantity change or gift sync is
  // pending (the re-render after them may still be running), or after the
  // timeout, so checkout is never held up for good.
  cartSettled(timeout = 10000) {
    const start = Date.now();
    return new Promise((resolve) => {
      const check = () => {
        // Without gift settings on the page the sync never runs (giftSynced
        // stays false), so there's nothing to wait for there.
        const idle = this.busy === 0 && this.pendingTargets.size === 0 && (this.giftSynced || !this.giftPromo);
        if (idle || Date.now() - start > timeout) resolve();
        else setTimeout(check, 50);
      };
      check();
    });
  }

  // ---- Discount codes -----------------------------------------------------
  // Codes are applied to the cart here, so a VIP gift code adds its gift
  // before checkout. During a gift promo, codes can't be used at all.
  applyDiscountCode(code) {
    if (!code) return;
    if (this.giftPromoRunning(this.lastCart)) {
      this.setDiscountMessage(this.codesBlockedMessage(), 'error');
      return;
    }
    this.setDiscountMessage(null);
    this.setDiscountBusy(true);
    this.requestStructureRender();
    this.enqueue(async () => {
      const cart = await this.fetchCart();
      const codes = (cart.discount_codes || []).map((entry) => entry.code);
      if (!codes.some((existing) => existing.toUpperCase() === code.toUpperCase())) codes.push(code);
      await this.updateCartDiscounts(codes);
      this.pendingDiscountCode = code;
      this.dirty = true;
    })
      .catch(() => this.setDiscountMessage(this.discountText('errorMsg'), 'error'))
      .finally(() => this.setDiscountBusy(false));
  }

  removeDiscountCode(code) {
    if (!code) return;
    this.removeDiscountCodes((existing) => existing.toUpperCase() === code.toUpperCase());
  }

  // Takes off every code in the cart that `matches` (code => boolean), and the
  // gifts they brought with them in the same request. Their chips and gift
  // cards go at once; the render that follows confirms it, or brings them
  // back if the request failed.
  removeDiscountCodes(matches) {
    const codes = ((this.lastCart && this.lastCart.discount_codes) || []).map((entry) => String(entry.code));
    const removing = codes.filter(matches);
    removing.forEach((code) => this.removingCodes.add(code.toUpperCase()));
    if (this.giftPromo) {
      // A gift goes unless another code in the cart brings it too.
      const kept = new Set(codes.filter((code) => !matches(code)).map((code) => this.vipRowForCode(code)));
      removing.forEach((code) => {
        const row = this.vipRowForCode(code);
        if (row && !kept.has(row)) this.hideGiftCards('vip:' + row.prefix);
      });
    }
    const chipFocused = !!document.activeElement?.closest?.('[data-discount-codes]');
    this.setDiscountMessage(null); // redraws the chips without them
    if (chipFocused) {
      // In an empty cart the toggle is hidden: the code field or "Have a code?".
      const inEmpty = !!this.sidecart.querySelector('[data-empty-code] [data-sidecart-discount]');
      const target = inEmpty
        ? this.sidecart.querySelector(this.discountOpen ? '[data-discount-input]' : '[data-empty-code-open]')
        : this.sidecart.querySelector('[data-discount-toggle]');
      target?.focus();
    }
    this.requestStructureRender();
    this.enqueue(async () => {
      try {
        let cart = this.lastCartFresh && this.lastCart ? this.lastCart : await this.fetchCart();
        for (let attempt = 0; ; attempt++) {
          const keep = (cart.discount_codes || []).map((entry) => entry.code).filter((existing) => !matches(existing));
          const updates = this.giftPromo ? this.giftFixes({ ...cart, discount_codes: keep.map((code) => ({ code })) }) : {};
          try {
            await this.updateCartDiscounts(keep, updates);
            break;
          } catch (err) {
            // Line keys from a cart changed since fail the whole request: once more, fresh.
            if (attempt) throw err;
            cart = await this.fetchCart();
          }
        }
        this.dirty = true;
      } finally {
        removing.forEach((code) => this.removingCodes.delete(code.toUpperCase()));
      }
    }).catch(() => this.setDiscountMessage(this.discountText('errorMsg'), 'error'));
  }

  // Sets the cart's codes, along with line updates by line key if any (one
  // request does both).
  async updateCartDiscounts(codes, updates = {}) {
    const body = { discount: codes.join(',') };
    if (Object.keys(updates).length) body.updates = updates;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('cart/update failed: ' + res.status);
    const cart = await res.json();
    this.lastCart = cart;
    this.lastCartFresh = true;
    return cart;
  }

  // After the render that follows applying a code: a code the cart can't use
  // gets a message (its chip stays, dimmed, so the customer can remove it). A
  // gift code whose gift waits for its scent applies once it's picked, so its
  // card comes into view instead.
  reportPendingDiscount(cart) {
    const code = this.pendingDiscountCode;
    if (!code) return;
    this.pendingDiscountCode = null;
    const entry = (cart.discount_codes || []).find(
      (existing) => String(existing.code).toUpperCase() === code.toUpperCase()
    );
    if (entry && entry.applicable) return;
    if (entry && this.giftChoiceCodes(this.pendingGiftChoices(cart)).includes(code.toUpperCase())) {
      this.unpickedGiftChoice()?.scrollIntoView({ block: 'nearest' });
      return;
    }
    // An empty cart: Shopify keeps any code but applies it to nothing yet, so
    // it's checked once something is added (see reportSavedCodes).
    if (entry && (cart.item_count || 0) === 0) {
      this.savedCodes.add(code.toUpperCase());
      this.storeSavedCodes();
      this.setDiscountMessage(this.discountText('savedMsg').replace('CODE', entry.code), 'saved');
      return;
    }
    this.setDiscountMessage(this.discountText('invalidMsg').replace('CODE', code), 'error');
  }

  // Codes saved in an empty cart, once it holds something (usually on another
  // page, so they're kept for the tab): one that still applies to nothing gets
  // the usual message, and "Saved!" goes.
  reportSavedCodes(cart) {
    if (!this.savedCodes.size || (cart.item_count || 0) === 0) return;
    const waiting = this.giftChoiceCodes(this.pendingGiftChoices(cart));
    const unused = (cart.discount_codes || []).find((entry) => {
      const code = String(entry.code).toUpperCase();
      return this.savedCodes.has(code) && !entry.applicable && !waiting.includes(code);
    });
    this.savedCodes.clear();
    this.storeSavedCodes();
    if (unused) {
      this.setDiscountMessage(this.discountText('invalidMsg').replace('CODE', unused.code), 'error');
    } else if (this.discountMessage && this.discountMessage.tone === 'saved') {
      this.setDiscountMessage(null);
    }
  }

  loadSavedCodes() {
    try {
      return new Set(JSON.parse(sessionStorage.getItem('baudie:saved-codes') || '[]'));
    } catch (e) {
      return new Set();
    }
  }

  storeSavedCodes() {
    try {
      if (this.savedCodes.size) sessionStorage.setItem('baudie:saved-codes', JSON.stringify(Array.from(this.savedCodes)));
      else sessionStorage.removeItem('baudie:saved-codes');
    } catch (e) {}
  }

  codesBlockedMessage() {
    return (this.giftPromo && this.giftPromo.codesBlockedMessage) || this.discountText('blockedMsg');
  }

  discountText(key) {
    const box = this.sidecart.querySelector('[data-sidecart-discount]');
    return (box && box.dataset[key]) || '';
  }

  // A message under the code box fades after a few seconds of being seen. If
  // it's set while the drawer is closed (e.g. a code from an email link removed
  // during a promo), the clock starts when the drawer opens.
  setDiscountMessage(text, tone = 'info') {
    this.discountMessage = text ? { text, tone } : null;
    clearTimeout(this.discountMessageTimer);
    const box = this.sidecart.querySelector('[data-sidecart-discount]');
    if (!box && text && tone === 'error') {
      this.showToast(text);
      this.discountMessage = null;
      return;
    }
    this.renderDiscountState(this.lastCart);
    if (text && this.sidecart.classList.contains('is-open')) this.startDiscountMessageTimer();
  }

  startDiscountMessageTimer() {
    clearTimeout(this.discountMessageTimer);
    this.discountMessageTimer = setTimeout(() => {
      this.discountMessage = null;
      this.renderDiscountState(this.lastCart);
    }, 8000);
  }

  setDiscountBusy(isBusy) {
    const box = this.sidecart.querySelector('[data-sidecart-discount]');
    if (!box) return;
    box.classList.toggle('is-loading', !!isBusy);
    const apply = box.querySelector('[data-discount-apply]');
    if (apply) apply.disabled = !!isBusy;
  }

  // Applied-code chips + the message, redrawn after every render (the footer
  // markup is replaced on each one).
  renderDiscountState(cart) {
    this.placeDiscountBox(cart);
    const box = this.sidecart.querySelector('[data-sidecart-discount]');
    if (!box) return;

    // The fold-out stays the way the customer left it, re-render or not.
    const toggle = box.querySelector('[data-discount-toggle]');
    const panel = box.querySelector('[data-discount-panel]');
    if (toggle && panel) {
      panel.hidden = !this.discountOpen;
      toggle.setAttribute('aria-expanded', this.discountOpen ? 'true' : 'false');
    }

    const list = box.querySelector('[data-discount-codes]');
    if (list) {
      const codes = (cart && cart.discount_codes) || [];
      const removeLabel = box.dataset.removeLabel || 'Remove CODE';
      // A gift code applies to nothing until its scent is picked, and any code
      // to nothing in an empty cart: not dimmed.
      const waiting = this.giftChoiceCodes(this.pendingGiftChoices(cart));
      const empty = !!cart && (cart.item_count || 0) === 0;
      list.innerHTML = '';
      codes.forEach((entry) => {
        if (this.removingCodes.has(String(entry.code).toUpperCase())) return; // on its way off
        const active = entry.applicable || empty || waiting.includes(String(entry.code).toUpperCase());
        const chip = document.createElement('li');
        chip.className = 'sidecart__discount-code' + (active ? '' : ' sidecart__discount-code--inactive');
        const label = document.createElement('span');
        label.textContent = entry.code;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sidecart__discount-remove';
        remove.dataset.discountRemove = entry.code;
        remove.setAttribute('aria-label', removeLabel.replace('CODE', entry.code));
        remove.innerHTML =
          '<svg aria-hidden="true" focusable="false" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
        chip.append(label, remove);
        list.appendChild(chip);
      });
      list.hidden = !list.children.length;
    }

    const message = box.querySelector('[data-discount-message]');
    if (message) {
      const current = this.discountMessage;
      message.hidden = !current;
      message.textContent = current ? current.text : '';
      message.classList.toggle('sidecart__discount-message--error', !!current && current.tone === 'error');
    }
  }

  // ---- Add to cart (routed through the same serialized chain) -------------
  handleAddSubmit(form) {
    const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
    const originalDisabled = submitBtn ? submitBtn.disabled : false;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    this.open();

    // For an in-drawer upsell add, drop the item in optimistically so it shows
    // instantly instead of after the add + section-render round-trip. Other adds
    // (e.g. from a product page) keep the loading state while the drawer renders.
    const offer = form.closest('[data-sidecart-upsell-offer]');
    const pending = offer ? this.insertPendingUpsellCard(offer) : null;
    if (!pending) this.markContentBusy(true);

    const fd = new FormData(form);
    const body = new URLSearchParams();
    const id = fd.get('id');
    if (id) body.append('id', id);
    body.append('quantity', fd.get('quantity') || '1');
    const sellingPlan = fd.get('selling_plan');
    if (sellingPlan) body.append('selling_plan', sellingPlan);
    for (const [k, v] of fd.entries()) {
      if (k.indexOf('properties[') === 0) body.append(k, v);
    }

    return this.addToCart(body)
      .catch((err) => {
        this.showToast((err && err.message) || 'Could not add item to cart. Please try again.');
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = originalDisabled || false;
          submitBtn.classList.remove('is-loading');
        }
      });
  }

  // Optimistically drop an upsell offer into the cart list so it appears
  // instantly. Clones an existing card for exact markup (SVG controls, classes,
  // translated remove label), then swaps in the offer's image/title/price. The
  // authoritative reconcile (reconcileRender) replaces it a moment later.
  // Returns the inserted card, or null if it couldn't build one (caller then
  // falls back to the loading spinner).
  insertPendingUpsellCard(offer) {
    const container = this.itemsContainer;
    // A free gift card has no quantity or remove controls, so it can't be the template.
    const template = this.sidecart.querySelector('[data-sidecart-item]:not([aria-hidden="true"]):not([data-gift])');
    if (!container || !template) return null;

    const form = offer.querySelector('form');
    const variantInput = form && form.querySelector('input[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId) return null;

    const title = (offer.querySelector('.sidecart-upsell__title')?.textContent || '').trim();
    const currentCents = this.parseMoney(offer.querySelector('.sidecart-upsell__current')?.textContent);
    const compareEl = offer.querySelector('.sidecart-upsell__compare');
    const compareCents = compareEl ? this.parseMoney(compareEl.textContent) : 0;
    if (!currentCents) return null;
    const originalCents = compareCents > currentCents ? compareCents : currentCents;

    const card = template.cloneNode(true);
    card.dataset.productId = offer.dataset.productId || '';
    card.dataset.variantId = String(variantId);
    card.dataset.propertiesSignature = String(variantId);
    card.dataset.lineCount = '1';
    card.dataset.inventory = '99999';
    card.dataset.inventoryPolicy = 'deny';
    card.dataset.compareAtUnit = '0';
    card.dataset.unitPrice = String(currentCents);
    card.dataset.originalUnit = String(originalCents);
    card.removeAttribute('aria-hidden');
    card.style.display = '';

    // Swap the image in. Reuse the template card's existing <img> when present
    // so the optimistic image inherits the exact sizing markup of a real card
    // (width/height attributes + object-fit) instead of rendering at the offer
    // thumbnail's natural size. Build one with matching dimensions otherwise.
    const imgLink = card.querySelector('.sidecart-item__image-link');
    const offerImg = offer.querySelector('.sidecart-upsell__image');
    if (imgLink && offerImg) {
      imgLink.removeAttribute('href');
      // Match the real card's image background (product_card_background metafield).
      imgLink.style.backgroundColor = offer.dataset.cardBg || '#FCF0D2';
      let img = imgLink.querySelector('img');
      if (!img) {
        imgLink.innerHTML = '';
        img = document.createElement('img');
        img.loading = 'lazy';
        img.setAttribute('width', '150');
        img.setAttribute('height', '194');
        imgLink.appendChild(img);
      }
      img.className = 'sidecart-item__image';
      // Request the cart-card resolution (the offer src is sized for a thumbnail)
      // and drop the offer's srcset so it doesn't override the chosen src.
      const offerSrc = offerImg.getAttribute('src') || '';
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = offerSrc.replace(/([?&]width=)\d+/, (_m, p) => p + '400');
      img.alt = title;
    }

    const titleEl = card.querySelector('.sidecart-item__title');
    if (titleEl) titleEl.textContent = title;
    ['.sidecart-item__variant', '.sidecart-item__subscription', '.sidecart-item__bundle-list', '.sidecart-item__properties', '.sidecart-item__bundle-bottles']
      .forEach((sel) => { const el = card.querySelector(sel); if (el) el.remove(); });

    const input = card.querySelector('[data-quantity]');
    if (input) { input.value = 1; input.defaultValue = '1'; }

    const warn = card.querySelector('[data-stock-warning]');
    if (warn) { warn.hidden = true; warn.textContent = ''; }

    this.renderCardPrice(card, 1, currentCents, originalCents);

    // Insert at the TOP: Shopify returns a newly added (discounted) line first
    // in cart.items, so the authoritative reconcile renders it at the top. We
    // place the optimistic card there too so it doesn't visibly jump.
    container.prepend(card);
    this.hideEmptyState();
    this.adjustCountBadge(1);
    this.adjustSubtotalOptimistic(currentCents);
    this.updateUpsellFromDOM();
    return card;
  }

  addToCart(body) {
    // An add introduces a new card -> needs the Liquid section re-render.
    this.requestStructureRender();
    return this.enqueue(async () => {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body
      });
      // add.js answers with the added line only, so the cached cart is stale.
      this.lastCartFresh = false;
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add item to cart');
      }
      this.dirty = true;
    });
  }

  // ---- Open / close -------------------------------------------------------
  open(trigger = null) {
    // A shipping race waits until the drawer has slid in: transitionend, or
    // this fallback when there's no transition to wait for.
    if (!this.sidecart.classList.contains('is-open')) {
      this.drawerReady = false;
      clearTimeout(this.drawerReadyTimer);
      this.drawerReadyTimer = setTimeout(() => this.drawerOpened(), 400);
    }
    this.triggerElement = trigger || document.activeElement;
    this.sidecart.classList.add('is-open');
    this.sidecart.setAttribute('aria-hidden', 'false');
    document.getElementById('cart-toggle')?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // Reconcile against the server whenever the drawer opens so a stale/ghost
    // line can never be shown (full render: the card set may have changed).
    this.lastCartFresh = false;
    this.requestStructureRender();
    this.enqueue(async () => {});
    if (this.discountMessage) this.startDiscountMessageTimer();
    setTimeout(() => this.closeButton?.focus(), 100);
  }

  // The drawer has finished sliding in: a race waiting for it starts now.
  drawerOpened() {
    clearTimeout(this.drawerReadyTimer);
    if (this.drawerReady || !this.sidecart.classList.contains('is-open')) return;
    this.drawerReady = true;
    if (this.shippingRacePending) this.raceShippingBar();
  }

  close() {
    this.drawerReady = false;
    clearTimeout(this.drawerReadyTimer);
    this.sidecart.classList.remove('is-open');
    this.sidecart.setAttribute('aria-hidden', 'true');
    document.getElementById('cart-toggle')?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    this.triggerElement?.focus();
  }

  handleKeydown(e) {
    if (!this.sidecart.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      // An open dropdown in the drawer takes the Escape (it closes only itself).
      if (!e.defaultPrevented) this.close();
      return;
    }
    if (e.key === 'Tab') {
      this.handleTabTrap(e);
    }
  }

  handleTabTrap(e) {
    const focusableElements = this.drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }

  // ---- Stock warning + toast ---------------------------------------------
  showStockWarning(itemEl, actualQty) {
    const warning = itemEl?.querySelector('[data-stock-warning]');
    if (!warning) return;

    const msg = this.sidecart.dataset.stockWarning || 'Only COUNT available';
    warning.textContent = msg.replace('COUNT', actualQty);
    warning.hidden = false;

    if (this.stockWarningTimeouts.has(itemEl)) {
      clearTimeout(this.stockWarningTimeouts.get(itemEl));
    }
    const timeout = setTimeout(() => {
      warning.hidden = true;
      this.stockWarningTimeouts.delete(itemEl);
    }, 8000);
    this.stockWarningTimeouts.set(itemEl, timeout);
  }

  showToast(msg) {
    const toast = document.createElement('div');
    toast.className = 'sidecart__toast';
    toast.textContent = msg;
    this.drawer?.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('sidecart__toast--visible'));
    setTimeout(() => {
      toast.classList.remove('sidecart__toast--visible');
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  formatMoney(cents) {
    const b = '{' + '{';
    const e = '}' + '}';
    const moneyFormat = this.sidecart?.dataset.moneyFormat || ('$' + b + 'amount' + e);
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.floor(cents / 100).toString();
    const amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountNoDecimalsWithCommas = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return moneyFormat
      .replace(b + 'amount_with_comma_separator' + e, amountWithCommas.replace('.', ','))
      .replace(b + 'amount_no_decimals_with_comma_separator' + e, amountNoDecimalsWithCommas.replace(/,/g, '.'))
      .replace(b + 'amount_with_apostrophe_separator' + e, amountWithCommas.replace(/,/g, "'"))
      .replace(b + 'amount_no_decimals' + e, amountNoDecimals)
      .replace(b + 'amount' + e, amount);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.__sidecartInstance = new Sidecart();
  });
} else {
  window.__sidecartInstance = new Sidecart();
}

(function initAjaxAddToCart() {
  function isProductForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    const action = form.getAttribute('action') || '';
    if (action.includes('/cart/add')) return true;
    if (form.querySelector('input[name="form_type"][value="product"]')) return true;
    return false;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.tagName === 'FORM' ? e.target : e.target.closest('form');
    if (!isProductForm(form)) return;
    // Forms that explicitly want a full-page redirect opt out of AJAX.
    if (form.querySelector('input[name="return_to"]')) return;

    e.preventDefault();

    const instance = window.__sidecartInstance;
    if (!instance) {
      form.submit();
      return;
    }
    instance.handleAddSubmit(form);
  });
})();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-sidecart]')) {
      const sidecart = document.getElementById('sidecart');
      if (sidecart) {
        sidecart.classList.add('is-open');
        sidecart.setAttribute('aria-hidden', 'false');
      }
    }
  });

  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('[data-sidecart]')) {
      const sidecart = document.getElementById('sidecart');
      if (sidecart) {
        sidecart.classList.remove('is-open');
        sidecart.setAttribute('aria-hidden', 'true');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
